import React, { Component } from 'react';

import { DatePicker, FontWeights, Separator } from 'office-ui-fabric-react/lib';
import { MyContext } from '../../../context';
import { queryGetConfigData, mutationMarkDeleteImportRule, getProcessingRegions, checkImportConnectionString } from "../../../queries/querySettings";
import { toast } from 'react-toastify';
import Utils from '../../common/Utils';
import DateTimePicker from 'react-datetime-picker';
import UserPicker from '../../ReportView/ReportConfiguration/UserPicker';
import { Query } from "@apollo/react-components";
import { IconButton, DetailsList } from "office-ui-fabric-react";

import gql from 'graphql-tag';

import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    ComboBox, Checkbox, Spinner, Text, Label, SpinButton, ChoiceGroup
    , Toggle
} from "office-ui-fabric-react";
import { iniGraphqlUrl } from "../../../ini/ini";
import UploadMappingFile from '../UploadMappingFile';



//IsInternalCheckField user properties
const userProperties = [
    "aboutMe", "accountEnabled", "ageGroup", "assignedLicenses", "assignedPlans", "birthday",
    "businessPhones", "Location", "Company Name", "consentProvidedForMinor", "Country/Region",
    "createdDateTime", "creationType", "customSecurityAttributes", "deletedDateTime", "department",
    "displayName", "employeeHireDate", "employeeLeaveDateTime", "employeeId", "employeeOrgData",
    "employeeType", "externalUserState", "externalUserStateChangeDateTime", "fax number", "givenName",
    "hireDate", "id", "identities", "imAddresses", "interests", "isManagementRestricted",
    "isResourceAccount", "jobTitle", "lastPasswordChangeDateTime", "legalAgeGroupClassification",
    "licenseAssignmentStates", "mail", "mailboxSettings", "emailNickname", "mobile phone", "mySite",
    "officeLocation", "onPremisesDistinguishedName", "onPremisesDomainName", "onPremisesExtensionAttributes",
    "onPremisesImmutableId", "onPremisesLastSyncDateTime", "onPremisesProvisioningErrors",
    "onPremisesSamAccountName", "onPremisesSecurityIdentifier", "onPremisesSyncEnabled",
    "onPremisesUserPrincipalName", "otherMails", "passwordPolicies", "passwordProfile", "pastProjects",
    "postal code", "preferredDataLocation", "preferredLanguage", "preferredName", "provisionedPlans",
    "proxyAddresses", "refreshTokensValidFromDateTime", "responsibilities", "serviceProvisioningErrors",
    "schools", "securityIdentifier", "showInAddressList", "signInActivity", "signInSessionsValidFromDateTime",
    "skills", "state", "streetAddress", "surname", "usageLocation", "userPrincipalName", "userType"
];


class ImportConfig extends React.Component {
    constructor(props) {
        super(props);


        //I added this part because for new jobs or existing recent jobs are fine with new Date() and new date(jobTime)
        //but we have old jobs that have as value '0001-01-01T00:00:00' and it's not working because it's not recognized as a valid DateTime because it reads as 0000-12-31T22:15:36.000Z
        //so in case of an old wrong value I will change it in 0001-01-01T00:00:00Z because the Z adds an extra 1h:44min and is able to read the date correct
        let jobTime = new Date();
        if (this.props.data != null && this.props.data.jobType != null) {
            if (this.props.data.jobType.jobStartTime === '0001-01-01T00:00:00') {
                jobTime = new Date('0001-01-01T00:00:00Z');
            } else if (this.props.data.jobType.jobStartTime === '') {
                jobTime = new Date();
            } else {
                jobTime = new Date(this.props.data.jobType.jobStartTime)
            }
        }
        let callStartTime = new Date();
        if (this.props.data != null && this.props.data.callStartTime != null) {
            if (this.props.data.callStartTime === '0001-01-01T00:00:00') {
                callStartTime = new Date('0001-01-01T00:00:00Z');
            } else if (this.props.data.callStartTime === '') {
                callStartTime = new Date();
            } else {
                callStartTime = new Date(this.props.data.callStartTime)
            }
        }
        let callEndTime = new Date();
        if (this.props.data != null && this.props.data.callEndTime != null) {
            if (this.props.data.callEndTime === '0001-01-01T00:00:00') {
                callEndTime = new Date('0001-01-01T00:00:00Z');
            } else if (this.props.data.callEndTime === '') {
                callEndTime = new Date();
            } else {
                callEndTime = new Date(this.props.data.callEndTime)
            }
        }


        let importUserGroupUsers = [];
        let importUserGroupIds = (this.props.data == null || this.props.data.userIds === "undefined" || this.props.data.userIds == null || this.props.data.userIds == "") ? "" : this.props.data.userIds;
        for (let x = 0; x < importUserGroupIds.length; x++) {
            importUserGroupUsers.push({
                userId: importUserGroupIds[x],
                key: importUserGroupIds[x]
            }
            );
        }

        // Initialize customFieldsMapping as an array of { key, value } objects
        let customFieldsMappingArr = [];
        if (!this.props.isNew && this.props.data && this.props.data.customFieldMapping) {
            try {
                // If it's a JSON string, parse it, else assume it's an object
                let mapping = typeof this.props.data.customFieldMapping === "string"
                    ? JSON.parse(this.props.data.customFieldMapping)
                    : this.props.data.customFieldMapping;
                if (mapping && typeof mapping === "object") {
                    customFieldsMappingArr = Object.entries(mapping).map(([key, value]) => ({ key, value }));
                }
            } catch {
                // fallback: treat as empty
                customFieldsMappingArr = [];
            }
        }

        const genericMappings = this.initializeGenericMappingsFromProps(this.props);

        // Determine isJson from props.data.metadataMapping if available
        let isJson = false;
        if (this.props.data && this.props.data.metadataMapping) {
            let metadataMappingObj = {};
            try {
                metadataMappingObj = typeof this.props.data.metadataMapping === "string"
                    ? JSON.parse(this.props.data.metadataMapping)
                    : this.props.data.metadataMapping;
            } catch {
                metadataMappingObj = {};
            }
            isJson = ((metadataMappingObj && metadataMappingObj.MetadataMappingType) || "").toUpperCase() === "JSON";
        }

        this.state = {
            name: this.props.data != null ? this.props.data.name : "Import",
            id: this.props.isNew ? Utils.guidGenerator() : this.props.data.id,
            jobStartTime: jobTime,
            intervalType: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalType : "OneTime",
            intervalMonth: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalMonth : 0,
            intervalDay: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalDay : 0,
            intervalHour: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalHour : 0,
            intervalMinute: (this.props.data != null && this.props.data.jobType != null) ? this.props.data.jobType.intervalMinute : 0,
            importType: (this.props.data != null && this.props.data.importType != null) ? this.props.data.importType : "Neo",
            mappingType: (this.props.data != null && this.props.data.mappingType != null) ? this.props.data.mappingType : "UsersToUsers",
            mappingUserId: (this.props.data == null || this.props.data.mappingUserId == null) ? [] : [{
                userId: this.props.data.mappingUserId
            }],
            sourceTtl: this.props.isNew ? -1 : this.props.data.sourceTtl,
            sourceTtlEnabled: this.props.isNew ? false : this.props.data.sourceTtl != -1,
            storageConnectionString: this.props.isNew ? "" : this.props.data.storageConnectionString,
            storageContainerName: this.props.isNew ? "ascimport" : this.props.data.storageContainerName,
            storageRootDirectory: this.props.isNew ? "" : this.props.data.storageRootDirectory,
            targetTtl: this.props.isNew ? "730" : this.props.data.targetTtl,
            enabled: this.props.isNew ? "true" : this.props.data.enabled,
            processingRegion: this.props.isNew ? "North Europe" : this.props.data.processingRegion,
            sftpPrivateKeyUpload: (this.props.data != null && this.props.data.sftpPrivateKeyUpload != null) ? this.props.data.sftpPrivateKeyUpload : "",
            hasSftpKey: (this.props.data !== null && this.props.data.hasSftpKey !== null) ? this.props.data.hasSftpKey : false,
            jobDeletionActive: false,
            callStartTime: callStartTime,
            callEndTime: callEndTime,
            userIds: importUserGroupUsers,
            transferId: this.props.isNew ? "" : this.props.data.transferId,
            downloadNeoTransferTextBtn: "downloadNeoTransferFile",
            customFieldsMapping: customFieldsMappingArr.length > 0 ? customFieldsMappingArr : [{ key: "", value: "" }],
            metadataMapping: this.props.isNew ? "" : (this.props.data.metadataMapping != null ? this.props.data.metadataMapping : ""),
            xmlCustomFieldsMappingRows: genericMappings.xmlCustomFieldsMappingRows,
            xmlMetadataMappingRows: genericMappings.xmlMetadataMappingRows,
            xmlDirectionMappingRows: genericMappings.xmlDirectionMappingRows,
            xmlParticipantMappingRows: genericMappings.xmlParticipantMappingRows,
            xmlTimeZone: genericMappings.xmlTimeZone,
            xmlDateTimeFormat: genericMappings.xmlDateTimeFormat,
            xmlParticipantMapType: genericMappings.xmlParticipantMapType,
            uploadedXmlMappings: genericMappings.uploadedXmlMappings,
            uploadedXMLFile: "",
            isMetadataMappingValid: null,
            isCustomFieldMappingValid: null,
            isValidUUID: true,
            validateStorageConnectionString: "",
            storageConnectionStringChanged: false,
            createUnmixedEnhancement: this.props.data?.createUnmixedEnhancement ?? (this.props.isNew && ["Neo", "NeoTransfer"].includes((this.props.data != null && this.props.data.importType != null) ? this.props.data.importType : "Neo")),
            callDateError: "",
            callEndIsClockOpen: false,
            mappingFiles: this.props.isNew ? [] : (this.props.data.mappingFiles || []),
            deletedFilesFromMappingFiles: [],
            uploadedJsonMappings: genericMappings.uploadedJsonMappings,
            uploadedJSONFile: "",
            jsonCustomFieldsMappingRows: genericMappings.jsonCustomFieldsMappingRows,
            jsonMetadataMappingRows: genericMappings.jsonMetadataMappingRows,
            jsonParticipantMappingRows: genericMappings.jsonParticipantMappingRows,
            jsonDirectionMappingRows: genericMappings.jsonDirectionMappingRows,
            jsonTimeZone: genericMappings.jsonTimeZone,
            jsonDateTimeFormat: genericMappings.jsonDateTimeFormat,
            jsonParticipantMapType: genericMappings.jsonParticipantMapType,
            jsonPostParticipantMappingRules: genericMappings.jsonPostParticipantMappingRules,
            FinalDirectionMappingRule: genericMappings.FinalDirectionMappingRule,
            isJson: isJson,
            timezonesList: []

        };
    }

    initializeGenericMappingsFromProps(props) {
        if (
            props &&
            props.data &&
            props.data.customFieldMapping &&
            props.data.metadataMapping &&
            (props.data.importType === "Generic" || (props.importType && props.importType === "Generic"))
        ) {
            // Parse customFieldMapping
            let customFieldMappingObj = {};
            try {
                customFieldMappingObj = typeof props.data.customFieldMapping === "string"
                    ? JSON.parse(props.data.customFieldMapping)
                    : props.data.customFieldMapping;
            } catch {
                customFieldMappingObj = {};
            }
            // Parse metadataMapping
            let metadataMappingObj = {};
            try {
                metadataMappingObj = typeof props.data.metadataMapping === "string"
                    ? JSON.parse(props.data.metadataMapping)
                    : props.data.metadataMapping;
            } catch {
                metadataMappingObj = {};
            }

            // Detect mapping type
            const mappingType = (metadataMappingObj.MetadataMappingType || "XML").toUpperCase();

            if (mappingType === "JSON") {
                // JSON initialization
                const jsonCustomFieldsMappingRows = Object.entries(customFieldMappingObj).map(([jsonPath, customField]) => ({
                    jsonPath,
                    customField
                }));

                const metadataMappings = metadataMappingObj.MetadataMappings || {};
                const jsonMetadataMappingRows = Object.entries(metadataMappings).map(([jsonPath, value]) => ({
                    jsonPath,
                    value
                }));

                const directionMappings = metadataMappingObj.DirectionMappings || {};
                const jsonDirectionMappingRows = Object.entries(directionMappings).map(([jsonKey, directionValue]) => ({
                    jsonKey,
                    directionValue
                }));

                const participantMappings = metadataMappingObj.ParticipantMappings || [];
                const jsonParticipantMappingRows = participantMappings.map(participant => ({
                    Mappings: Object.entries(participant.Mapping || {}).map(([mappingKey, value]) => ({
                        mappingKey,
                        value
                    })),
                    IsCaller: participant.IsCaller === true,
                    IsCalled: participant.IsCalled === true,
                    IsCallOwner: participant.IsCallOwner === true,
                    IsInternalCheckField: participant.IsInternalCheckField || null,
                    IsCallOwnerCheckField: participant.IsCallOwnerCheckField || ""
                }));

                const jsonTimeZone = metadataMappingObj.TimeZone || "";
                const jsonDateTimeFormat = metadataMappingObj.DateTimeFormat || "";
                const jsonParticipantMapType = metadataMappingObj.ParticipantMapType || "";
                const jsonPostParticipantMappingRules = metadataMappingObj.PostParticipantMappingRules || [{
                    ParticipantTargetField: "",
                    MetadataFieldPath: "",
                    ComparisonMethod: "",
                    Reason: ""
                }];
                const FinalDirectionMappingRule = metadataMappingObj.FinalDirectionMappingRule || {
                    ParticipantTargetField: "",
                    MetadataFieldPath: "",
                    IsCaller: false
                };

                return {
                    // XML fields empty
                    xmlCustomFieldsMappingRows: [],
                    xmlMetadataMappingRows: [],
                    xmlDirectionMappingRows: [],
                    xmlParticipantMappingRows: [],
                    xmlTimeZone: "",
                    xmlDateTimeFormat: "",
                    xmlParticipantMapType: "",
                    uploadedXmlMappings: null,
                    // JSON fields
                    jsonCustomFieldsMappingRows,
                    jsonMetadataMappingRows,
                    jsonDirectionMappingRows,
                    jsonParticipantMappingRows,
                    jsonTimeZone,
                    jsonDateTimeFormat,
                    jsonParticipantMapType,
                    uploadedJsonMappings: {
                        customFieldMapping: customFieldMappingObj,
                        MetadataMapping: metadataMappingObj
                    },
                    jsonPostParticipantMappingRules,
                    FinalDirectionMappingRule
                };
            } else {
                // XML initialization (original logic)
                var xmlCustomFieldsMappingRows = Object.entries(customFieldMappingObj).map(([xpath, customField]) => ({
                    xpath,
                    customField
                }));

                const metadataMappings = metadataMappingObj.MetadataMappings || {};
                var xmlMetadataMappingRows = Object.entries(metadataMappings).map(([xpath, value]) => ({
                    xpath,
                    value
                }));

                const directionMappings = metadataMappingObj.DirectionMappings || {};
                var xmlDirectionMappingRows = Object.entries(directionMappings).map(([xmlKey, directionValue]) => ({
                    xmlKey,
                    directionValue
                }));

                const participantMappings = metadataMappingObj.ParticipantMappings || [];
                var xmlParticipantMappingRows = participantMappings.map(participant => ({
                    Mappings: Object.entries(participant.Mapping || {}).map(([mappingKey, value]) => ({
                        mappingKey,
                        value
                    })),
                    IsCaller: participant.IsCaller === true,
                    IsCalled: participant.IsCalled === true,
                    IsCallOwner: participant.IsCallOwner === true,
                    IsInternalCheckField: participant.IsInternalCheckField
                        ? Object.entries(participant.IsInternalCheckField).map(([xmlFieldName, logicalProperty]) => ({ xmlFieldName, logicalProperty }))
                        : [],
                    IsCallOwnerCheckField: participant.IsCallOwnerCheckField || ""
                }));

                var xmlTimeZone = metadataMappingObj.TimeZone || "";
                var xmlDateTimeFormat = metadataMappingObj.DateTimeFormat || "";
                var xmlParticipantMapType = metadataMappingObj.ParticipantMapType || "Single";

                var uploadedXmlMappings = {
                    customFieldMapping: customFieldMappingObj,
                    MetadataMapping: metadataMappingObj
                };

                return {
                    xmlCustomFieldsMappingRows,
                    xmlMetadataMappingRows,
                    xmlDirectionMappingRows,
                    xmlParticipantMappingRows,
                    xmlTimeZone,
                    xmlDateTimeFormat,
                    xmlParticipantMapType,
                    uploadedXmlMappings,
                    // JSON fields empty
                    jsonCustomFieldsMappingRows: [],
                    jsonMetadataMappingRows: [],
                    jsonDirectionMappingRows: [],
                    jsonParticipantMappingRows: [],
                    jsonTimeZone: "",
                    jsonDateTimeFormat: "",
                    jsonParticipantMapType: "",
                    uploadedJsonMappings: null,
                    jsonPostParticipantMappingRules: [{
                        ParticipantTargetField: "",
                        MetadataFieldPath: "",
                        ComparisonMethod: "",
                        Reason: ""
                    }],
                    FinalDirectionMappingRule: {
                        ParticipantTargetField: "",
                        MetadataFieldPath: "",
                        IsCaller: false
                    }
                };
            }
        }
        // Default empty values
        return {
            xmlCustomFieldsMappingRows: [],
            xmlMetadataMappingRows: [],
            xmlDirectionMappingRows: [],
            xmlParticipantMappingRows: [],
            xmlTimeZone: "",
            xmlDateTimeFormat: "",
            xmlParticipantMapType: "",
            uploadedXmlMappings: null,
            jsonCustomFieldsMappingRows: [],
            jsonMetadataMappingRows: [],
            jsonDirectionMappingRows: [],
            jsonParticipantMappingRows: [],
            jsonTimeZone: "",
            jsonDateTimeFormat: "",
            jsonParticipantMapType: "",
            uploadedJsonMappings: null,
            jsonPostParticipantMappingRules: [{
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                ComparisonMethod: "",
                Reason: ""
            }],
            FinalDirectionMappingRule: {
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                IsCaller: false
            }
        };
    }
    componentDidMount() {
        try {
            const timezones = Intl.supportedValuesOf('timeZone');
            this.setState({ timezonesList: timezones });
        } catch (error) {
            console.error("Error getting timezones:", error);
        }
    }

    loadFile = async (file) => {
        let text = await file.text();
        this.setState({ sftpPrivateKeyUpload: text });
    }

    onFileChange = event => {

        let activeFile = event.target.files[0];

        if (activeFile) {
            this.setState({ hasSftpKey: true });

        }

        if (event.target.files[0]) {

            this.loadFile(event.target.files[0]);
        }

    };

    downloadNeoTransferFile = async () => {
        this.setState({ downloadNeoTransferTextBtn: "downloading" });
        let data = await this.props.apol
            .mutate({
                mutation: gql`
                mutation ent ($input: AuthInput, $transferId:String, $graphAPIUri:String) {
                    downloadNeoTransferFile (input: $input, transferId:$transferId, graphAPIUri:$graphAPIUri) 
                }
            `,
                variables: {
                    input: this.props.authorization,
                    transferId: this.state.transferId,
                    graphAPIUri: iniGraphqlUrl
                },
            });
        if (data.data.downloadNeoTransferFile !== null) {
            let content = data.data.downloadNeoTransferFile;
            if (!content) {
                toast.error('Download not successful', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.setState({ downloadNeoTransferTextBtn: "downloadNeoTransferFile" });

            } else {
                let blob = new Blob([content], { type: "text/plain" });
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = "transfer_[" + this.props.data.tenantId + "]_[" + this.state.transferId + "].bin";
                a.click();
                this.setState({ downloadNeoTransferTextBtn: "downloadNeoTransferFile" });
            }

        }
    }

    validateUUID = (value) => {
        if (value === "") {
            return true;
        }
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidRegex.test(value);
    }

    handleTransferIdChange = (event, newValue) => {
        const isValidUUID = this.validateUUID(newValue);
        this.setState({ transferId: newValue, isValidUUID });
    }

    checkStorageConnectionString = async () => {
        this.setState({ validateStorageConnectionString: "pending" });

        document.getElementById("storageConnectionString").style.border = "";
        document.getElementById("storageContainerName").style.border = "";
        document.getElementById("storageConnectionStringError").innerHTML = "";
        document.querySelector("#checkBtn").style.border = "";

        var data = await this.props.apol.mutate({
            mutation: checkImportConnectionString,
            variables: {
                input: this.props.authorization,
                importRuleType: this.state.importType,
                storageConnectionString: this.state.storageConnectionString,
                storageContainerName: this.state.storageContainerName,
                neoTransferId: this.state.transferId
            },
        });

        switch (data.data.checkImportConnectionString) {
            case "EmptyConnectionString":
                document.getElementById("storageConnectionString").style.border = "1px solid red";
                document.getElementById("storageContainerName").style.border = "1px solid red";
                document.getElementById("storageConnectionStringError").innerHTML = "Storage connection string cannot be empty. Please provide a valid connection string.";
                toast.error("Storage connection string is required and cannot be empty", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid red";
                this.setState({ validateStorageConnectionString: "false" });
                break;

            case "MissingValueFromConnectionString":
                document.getElementById("storageConnectionString").style.border = "1px solid red";
                document.getElementById("storageContainerName").style.border = "1px solid red";
                document.getElementById("storageConnectionStringError").innerHTML = "Connection string is missing required values. Please check the format and ensure all necessary parameters are included.";
                toast.error("Connection string is incomplete. Missing required parameters.", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid red";
                this.setState({ validateStorageConnectionString: "false" });
                break;

            case "InvalidFormat":
                document.getElementById("storageConnectionString").style.border = "1px solid red";
                document.getElementById("storageContainerName").style.border = "1px solid red";
                document.getElementById("storageConnectionStringError").innerHTML = "Connection string format is invalid. Please verify the syntax and parameter names.";
                toast.error("Invalid connection string format, please check syntax", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid red";
                this.setState({ validateStorageConnectionString: "false" });
                break;

            case "InaccesibleResource":
                document.getElementById("storageConnectionString").style.border = "1px solid red";
                document.getElementById("storageContainerName").style.border = "1px solid red";
                document.getElementById("storageConnectionStringError").innerHTML = "Unable to access the storage resource. Please verify your connection string and ensure the resource is available.";
                toast.error("Storage resource is inaccessible, check connection and permissions", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid red";
                this.setState({ validateStorageConnectionString: "false" });
                break;

            case "Valid":
                document.getElementById("storageConnectionString").style.border = "1px solid green";
                document.getElementById("storageContainerName").style.border = "1px solid green";
                document.getElementById("storageConnectionStringError").innerHTML = "";
                toast.success("Storage connection string is valid", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid green";
                this.setState({ validateStorageConnectionString: "true" });
                break;

            case "UnknownError":
                document.getElementById("storageConnectionString").style.border = "1px solid red";
                document.getElementById("storageContainerName").style.border = "1px solid red";
                document.getElementById("storageConnectionStringError").innerHTML = "An unexpected error occurred while validating the connection string. Please try again.";
                toast.error("Validation failed due to an unexpected error, please try again", { autoClose: 5000, position: "bottom-left" });
                document.querySelector("#checkBtn").style.border = "1px solid red";
                this.setState({ validateStorageConnectionString: "false" });
                break;

        }
    };

    //hamdle custom field mapping for Neo import
    handleCustomFieldChange = (idx, field, newValue) => {
        this.setState(prevState => {
            const updated = prevState.customFieldsMapping.map((item, i) =>
                i === idx ? { ...item, [field]: newValue } : item
            );
            return { customFieldsMapping: updated };
        });
    };

    handleAddCustomField = () => {
        this.setState(prevState => ({
            customFieldsMapping: [...prevState.customFieldsMapping, { key: "", value: "" }]
        }));
    };

    handleRemoveCustomField = (idx) => {
        this.setState(prevState => {
            const updated = prevState.customFieldsMapping.filter((_, i) => i !== idx);
            return { customFieldsMapping: updated.length > 0 ? updated : [{ key: "", value: "" }] };
        });
    };

    //--------------------------------GENERIC IMPORT TYPE  XML MAPPINGS --------------------------------//
    //generc xml upload
    handleXmlUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const text = await file.text();
        let parser = new window.DOMParser();
        let xmlDoc = parser.parseFromString(text, 'text/xml');
        const mappings = this.transformXmlToMappings(xmlDoc);
        const xpaths = Object.keys(mappings.customFieldMapping || {});
        const metadataXPaths = Object.keys(mappings.MetadataMapping.MetadataMappings || {});
        const participantMappings = mappings.MetadataMapping.ParticipantMappings || [];
        const xmlParticipantMappingRows = participantMappings.map(participant => ({
            Mappings: [{ mappingKey: undefined, value: '' }],
            IsCaller: participant.IsCaller === true,
            IsCalled: participant.IsCalled === true,
            IsCallOwner: participant.IsCallOwner === true,
            IsInternalCheckField: participant.IsInternalCheckField || {},
            IsCallOwnerCheckField: participant.IsCallOwnerCheckField || ""
        }));
        const directionKeys = Object.keys(mappings.MetadataMapping.DirectionMappings || {});

        // Clear JSON-related states
        this.setState({
            uploadedJsonMappings: null,
            jsonCustomFieldsMappingRows: [],
            jsonMetadataMappingRows: [],
            jsonParticipantMappingRows: [],
            jsonDirectionMappingRows: [],
            uploadedJSONFile: "",
            jsonTimeZone: "",
            jsonDateTimeFormat: "",
            jsonParticipantMapType: "",
            jsonPostParticipantMappingRules: [{
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                ComparisonMethod: "",
                Reason: ""
            }],
            FinalDirectionMappingRule: {
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                IsCaller: false
            },
            // Set XML-related states
            uploadedXmlMappings: mappings,
            xmlCustomFieldsMappingRows: xpaths.length > 0 ? [{ xpath: '', customField: '' }] : [],
            xmlMetadataMappingRows: metadataXPaths.length > 0 ? [{ xpath: '', value: '' }] : [],
            xmlParticipantMappingRows,
            participantMappingCheckboxes: {},
            xmlDirectionMappingRows: directionKeys.length > 0 ? [{ xmlKey: '', directionValue: '' }] : [],
            uploadedXMLFile: text,
            isJson: false
        });
    };

    //convert xml to mappings
    transformXmlToMappings = (xmlDoc) => {
        function getXPath(node) {
            if (node.nodeType === 1) {
                let path = node.nodeName;
                let parent = node.parentNode;
                let siblings = Array.from(parent ? parent.children : []);
                let sameTagSiblings = siblings.filter(n => n.nodeName === node.nodeName);
                if (sameTagSiblings.length > 1) {
                    let idx = sameTagSiblings.indexOf(node) + 1;
                    path += `[${idx}]`;
                }
                if (parent && parent.nodeType === 1) {
                    return getXPath(parent) + "/" + path;
                } else {
                    return "//" + path;
                }
            } else if (node.nodeType === 2) {
                return getXPath(node.ownerElement) + `/@${node.nodeName}`;
            }
            return '';
        }

        const customFieldMapping = {};
        const MetadataMappings = {};
        const ParticipantMappings = [];

        let directionMappings = {};
        const root = xmlDoc.documentElement;
        for (let i = 0; i < root.childNodes.length; i++) {
            const child = root.childNodes[i];
            if (child.nodeType === 1 && child.nodeName.toLowerCase() === 'direction') {
                const value = child.textContent.trim();
                if (value) {
                    directionMappings[value] = value;
                }
            }
        }
        function isCustomField(node) {
            if (node.nodeType !== 1) return false;
            if (node.nodeName === 'ParmEntry' && node.hasAttribute('key') && node.hasAttribute('value')) return true;
            if (node.nodeName === 'conversationParameter') return true;
            if (node.nodeName === 'agentId' || node.nodeName === 'channelNumber' || node.nodeName === 'id') return true;
            return false;
        }

        function extractCustomFields(node, insideParticipant = false) {
            if (node.nodeType === 1) {
                // If inside a participant, skip all children
                if (insideParticipant || node.nodeName.toLowerCase() === 'participant' || node.nodeName.toLowerCase() === 'participants') {
                    return;
                }
                if (node.nodeName === 'ParmEntry' && node.hasAttribute('key') && node.hasAttribute('value')) {
                    const xpath = `//CallInfo/CallDetails/ParmEntry[@key='${node.getAttribute('key')}']/@value`;
                    customFieldMapping[xpath] = node.getAttribute('value');
                }
                if (node.nodeName === 'conversationParameter') {
                    const nameNode = Array.from(node.childNodes).find(n => n.nodeName === 'name');
                    const valueNode = Array.from(node.childNodes).find(n => n.nodeName === 'value');
                    if (nameNode && valueNode) {
                        const xpath = `//conversation/conversationParameters/conversationParameter[name="${nameNode.textContent.trim()}"]/value`;
                        customFieldMapping[xpath] = valueNode.textContent.trim();
                    }
                }
                if (node.nodeName === 'agentId' || node.nodeName === 'channelNumber' || node.nodeName === 'id') {
                    const xpath = getXPath(node);
                    customFieldMapping[xpath] = node.textContent.trim();
                }
                for (let i = 0; i < node.childNodes.length; i++) {
                    extractCustomFields(node.childNodes[i], insideParticipant || node.nodeName.toLowerCase() === 'participant' || node.nodeName.toLowerCase() === 'participants');
                }
            }
        }


        function extractParticipants(node) {
            if (node.nodeType === 1) {
                if (node.nodeName.toLowerCase() === 'participant') {
                    const mapping = {};
                    let IsCaller = false, IsCalled = false, IsCallOwner = false, IsInternalCheckField = {}, IsCallOwnerCheckField = "";
                    for (let i = 0; i < node.childNodes.length; i++) {
                        const child = node.childNodes[i];
                        if (child.nodeType === 1) {
                            mapping[child.nodeName] = {
                                value: child.textContent.trim(),
                                xpath: getXPath(child)
                            };                            // Check for checkbox fields
                            if (child.nodeName === 'IsCaller') IsCaller = child.textContent.trim().toLowerCase() === 'true';
                            if (child.nodeName === 'IsCalled') IsCalled = child.textContent.trim().toLowerCase() === 'true';
                            if (child.nodeName === 'IsCallOwner') IsCallOwner = child.textContent.trim().toLowerCase() === 'true';
                            if (child.nodeName === 'IsCallOwnerCheckField') {
                                IsCallOwnerCheckField = child.textContent.trim();
                            }
                            if (child.nodeName === 'IsInternalCheckField') {
                                // If the node has children, build a dictionary from them
                                if (child.childNodes && child.childNodes.length > 0) {
                                    let dict = {};
                                    for (let j = 0; j < child.childNodes.length; j++) {
                                        const sub = child.childNodes[j];
                                        if (sub.nodeType === 1) {
                                            dict[sub.nodeName] = sub.textContent.trim();
                                        }
                                    }
                                    IsInternalCheckField = dict;
                                } else {
                                    // Fallback: treat as a single value dictionary
                                    IsInternalCheckField = { value: child.textContent.trim() };
                                }
                            }
                        }
                    }
                    ParticipantMappings.push({
                        Mapping: mapping,
                        IsCaller,
                        IsCalled,
                        IsCallOwner,
                        IsInternalCheckField,
                        IsCallOwnerCheckField
                    });
                }
                for (let i = 0; i < node.childNodes.length; i++) {
                    extractParticipants(node.childNodes[i]);
                }
            }
        }

        function extractMetadata(node) {
            if (node.nodeType === 1) {
                for (let i = 0; i < node.childNodes.length; i++) {
                    const child = node.childNodes[i];
                    if (child.nodeType === 1) {
                        if (!isCustomField(child) && child.nodeName !== 'CallDetails' && child.nodeName.toLowerCase() !== 'participants' && child.nodeName !== 'conversationParameters') {
                            const xpath = `//${node.nodeName}/${child.nodeName}`;
                            MetadataMappings[xpath] = child.textContent.trim();
                        }
                    }
                }
            }
        }
        function collectDirections(node) {
            if (node.nodeType === 1 && node.nodeName.toLowerCase() === 'direction') {
                const value = node.textContent.trim();
                if (value) directionMappings[value] = value;
            }
            for (let i = 0; i < node.childNodes.length; i++) {
                collectDirections(node.childNodes[i]);
            }
        }

        collectDirections(xmlDoc.documentElement);
        extractCustomFields(xmlDoc.documentElement);
        extractParticipants(xmlDoc.documentElement);
        extractMetadata(xmlDoc.documentElement);

        return {
            customFieldMapping,
            MetadataMapping: {
                MetadataMappings,
                DirectionMappings: directionMappings,
                ParticipantMappings,
                TimeZone: '',
                DateTimeFormat: '',
                ParticipantMapType: ''
            }
        };
    };

    //custom field mappings
    handleXmlCustomFieldsMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlCustomFieldsMappingRows];
            rows[idx][field] = value;
            return { xmlCustomFieldsMappingRows: rows };
        });
    };

    handleAddXmlCustomFieldsMappingRowUI = () => {
        this.setState(prevState => ({
            xmlCustomFieldsMappingRows: [...(prevState.xmlCustomFieldsMappingRows || []), { xpath: '', customField: '' }]
        }));
    };

    handleRemoveXmlCustomFieldsMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.xmlCustomFieldsMappingRows.filter((_, i) => i !== idx);
            return { xmlCustomFieldsMappingRows: rows.length > 0 ? rows : [{ xpath: '', customField: '' }] };
        });
    };
    //metadata mappings
    handleMetadataMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlMetadataMappingRows];
            rows[idx][field] = value;
            return { xmlMetadataMappingRows: rows };
        });
    };

    handleAddMetadataMappingRowUI = () => {
        this.setState(prevState => ({
            xmlMetadataMappingRows: [...(prevState.xmlMetadataMappingRows || []), { xpath: '', value: '' }]
        }));
    };

    handleRemoveMetadataMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.xmlMetadataMappingRows.filter((_, i) => i !== idx);
            return { xmlMetadataMappingRows: rows.length > 0 ? rows : [{ xpath: '', value: '' }] };
        });
    };

    //participant mapping
    handleParticipantMappingRowChange = (idx, rowIdx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlParticipantMappingRows];
            const mappings = [...rows[idx].Mappings];
            mappings[rowIdx][field] = value;
            rows[idx].Mappings = mappings;
            return { xmlParticipantMappingRows: rows };
        });
    };

    handleAddParticipantMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlParticipantMappingRows];
            rows[idx].Mappings.push({ mappingKey: undefined, value: '' });
            return { xmlParticipantMappingRows: rows };
        });
    };

    handleRemoveParticipantMappingRowUI = (idx, rowIdx) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlParticipantMappingRows];
            rows[idx].Mappings = rows[idx].Mappings.filter((_, i) => i !== rowIdx);
            if (rows[idx].Mappings.length === 0) rows[idx].Mappings = [{ mappingKey: undefined, value: '' }];
            return { xmlParticipantMappingRows: rows };
        });
    };

    handleParticipantMappingCheckboxChange = (idx, field, checked) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlParticipantMappingRows];
            rows[idx][field] = checked;
            return { xmlParticipantMappingRows: rows };
        });
    };
    //direction mapping
    handleDirectionMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.xmlDirectionMappingRows];
            rows[idx][field] = value;
            return { xmlDirectionMappingRows: rows };
        });
    };

    handleAddDirectionMappingRowUI = () => {
        this.setState(prevState => ({
            xmlDirectionMappingRows: [...(prevState.xmlDirectionMappingRows || []), { xmlKey: '', directionValue: '' }]
        }));
    };

    handleRemoveDirectionMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.xmlDirectionMappingRows.filter((_, i) => i !== idx);
            return { xmlDirectionMappingRows: rows.length > 0 ? rows : [{ xmlKey: '', directionValue: '' }] };
        });
    };

    getImportMappingResult = () => {
        // Convert customFieldMapping array to dictionary
        let customFieldMappingDict = {};
        let customFieldMappingArr = this.state.xmlCustomFieldsMappingRows;
        if (
            Array.isArray(customFieldMappingArr) &&
            customFieldMappingArr.length === 1 &&
            (!customFieldMappingArr[0].xpath || customFieldMappingArr[0].xpath === '') &&
            (!customFieldMappingArr[0].customField || customFieldMappingArr[0].customField === '')
        ) {
            customFieldMappingArr = [];
        }
        customFieldMappingArr.forEach(({ xpath, customField }) => {
            if (xpath && customField) {
                customFieldMappingDict[xpath] = customField;
            }
        });

        // Convert MetadataMappings array to dictionary
        let MetadataMappingsDict = {};
        let MetadataMappingsArr = this.state.xmlMetadataMappingRows;
        if (
            Array.isArray(MetadataMappingsArr) &&
            MetadataMappingsArr.length === 1 &&
            (!MetadataMappingsArr[0].xpath || MetadataMappingsArr[0].xpath === '') &&
            (!MetadataMappingsArr[0].value || MetadataMappingsArr[0].value === '')
        ) {
            MetadataMappingsArr = [];
        }
        MetadataMappingsArr.forEach(({ xpath, value }) => {
            if (xpath && value) {
                MetadataMappingsDict[xpath] = value;
            }
        });

        // Convert DirectionMappings array to dictionary
        let DirectionMappingsDict = {};
        let DirectionMappingsArr = this.state.xmlDirectionMappingRows;
        if (
            Array.isArray(DirectionMappingsArr) &&
            DirectionMappingsArr.length === 1 &&
            (!DirectionMappingsArr[0].xmlKey || DirectionMappingsArr[0].xmlKey === '') &&
            (!DirectionMappingsArr[0].directionValue || DirectionMappingsArr[0].directionValue === '')
        ) {
            DirectionMappingsArr = [];
        }
        DirectionMappingsArr.forEach(({ xmlKey, directionValue }) => {
            if (xmlKey && directionValue) {
                DirectionMappingsDict[xmlKey] = directionValue;
            }
        });

        // ParticipantMappings: array, but Mapping inside each participant is a dictionary
        let ParticipantMappings = (this.state.xmlParticipantMappingRows || []).map(participant => {
            let mappingsArr = participant.Mappings;
            let mappingsDict = {};
            if (
                Array.isArray(mappingsArr) &&
                mappingsArr.length === 1 &&
                (!mappingsArr[0].mappingKey || mappingsArr[0].mappingKey === '') &&
                (!mappingsArr[0].value || mappingsArr[0].value === '')
            ) {
                mappingsArr = [];
            }
            mappingsArr.forEach(({ mappingKey, value }) => {
                if (mappingKey && value) {
                    mappingsDict[mappingKey] = value;
                }
            });
            // Copy participant, but replace Mappings array with Mapping dictionary
            const { Mappings, ...rest } = participant;
            return {
                ...rest,
                Mapping: mappingsDict
            };
        });

        // Compose the final structure
        return {
            customFieldMapping: customFieldMappingDict,
            MetadataMapping: {
                MetadataMappings: MetadataMappingsDict,
                MetadataMappingType: "XML",
                DirectionMappings: DirectionMappingsDict,
                ParticipantMappings,
                TimeZone: this.state.xmlTimeZone,
                DateTimeFormat: this.state.xmlDateTimeFormat,
                ParticipantMapType: this.state.xmlParticipantMapType,
                FinalDirectionMappingRule: this.state.FinalDirectionMappingRule

            }
        };
    };
    validateMetadataImport = async () => {
        // Use JSON mapping and file if JSON is uploaded, otherwise use XML
        const isJson = this.state.isJson;
        const importMapping = isJson
            ? JSON.stringify(this.getJsonImportMappingResult().MetadataMapping)
            : JSON.stringify(this.getImportMappingResult().MetadataMapping);
        const fileContent = isJson
            ? this.state.uploadedJSONFile
            : this.state.uploadedXMLFile;
        const timeZone = isJson ? this.state.jsonTimeZone : this.state.xmlTimeZone;
        const dateTimeFormat = isJson ? this.state.jsonDateTimeFormat : this.state.xmlDateTimeFormat;

        try {
            const result = await this.props.apol.mutate({
                mutation: gql`
                mutation validateImportMetadataMappingWithXML($input: AuthInput, $xmlContent: String, $importMapping: String, $timeZone: String, $dateTimeFormat: String) {
                    validateImportMetadataMappingWithXML(input: $input, xmlContent: $xmlContent, importMapping: $importMapping, timeZone: $timeZone, dateTimeFormat: $dateTimeFormat)
                }
            `,
                variables: {
                    input: this.props.authorization,
                    xmlContent: fileContent,
                    importMapping,
                    timeZone,
                    dateTimeFormat
                }
            });
            const validationResult = result.data.validateImportMetadataMappingWithXML;
            const isValid = validationResult === "Valid";
            this.setState({ isMetadataMappingValid: isValid });
            if (document.getElementById("validate-metadata-mapping"))
                document.getElementById("validate-metadata-mapping").style.borderColor = isValid ? "#4caf50" : "#f44336";

            switch (validationResult) {
                case "Valid":
                    toast.success("Metadata mapping is valid!", { position: "bottom-left" });
                    break;
                case "InvalidDateFormat":
                    toast.error("Invalid date format. Please check the DateTimeFormat and TimeZone settings.", { position: "bottom-left" });
                    break;
                case "InvalidMapping":
                    toast.error("Invalid mapping. Please verify your metadata mapping configuration.", { position: "bottom-left" });
                    break;
                case "UnknownError":
                    toast.error("An unknown error occurred during validation. Please try again.", { position: "bottom-left" });
                    break;
                default:
                    toast.error("Metadata mapping is invalid!", { position: "bottom-left" });
                    break;
            }
        } catch (err) {
            this.setState({ isMetadataMappingValid: false });
            toast.error("Validation failed: " + err.message, { position: "bottom-left" });
        }
    }

    // Update validateCustomFieldImport
    validateCustomFieldImport = async () => {
        // Use JSON mapping and file if JSON is uploaded, otherwise use XML
        const isJson = this.state.isJson;
        const importMapping = isJson
            ? JSON.stringify(this.getJsonImportMappingResult().customFieldMapping)
            : JSON.stringify(this.getImportMappingResult().customFieldMapping);
        const fileContent = isJson
            ? this.state.uploadedJSONFile
            : this.state.uploadedXMLFile;

        try {
            const result = await this.props.apol.mutate({
                mutation: gql`
                mutation validateImportCustomFieldMappingWithXML($input: AuthInput, $xmlContent: String, $importMapping: String) {
                    validateImportCustomFieldMappingWithXML(input: $input, xmlContent: $xmlContent, importMapping: $importMapping)
                }
            `,
                variables: {
                    input: this.props.authorization,
                    xmlContent: fileContent,
                    importMapping
                }
            });
            const isValid = !!result.data.validateImportCustomFieldMappingWithXML;
            this.setState({ isCustomFieldMappingValid: isValid });
            if (document.getElementById("validate-custom-fields-mapping"))
                document.getElementById("validate-custom-fields-mapping").style.borderColor = isValid ? "#4caf50" : "#f44336";

            if (isValid) {
                toast.success("Custom field mapping is valid!", { position: "bottom-left" });
            } else {
                toast.error("Custom field mapping is invalid!", { position: "bottom-left" });
            }
        } catch (err) {
            this.setState({ isCustomFieldMappingValid: false });
            toast.error("Validation failed: " + err.message, { position: "bottom-left" });
        }
    }
    isCustomFieldMappingReady = () => {
        // Determine if JSON or XML is active
        const isJson = this.state.isJson;
        const rows = isJson
            ? this.state.jsonCustomFieldsMappingRows || []
            : this.state.xmlCustomFieldsMappingRows || [];

        // Validation logic
        const hasValidRow = rows.some(row =>
            isJson ? row.jsonPath && row.customField : row.xpath && row.customField
        );
        const allRowsValid = rows.every(row =>
            isJson
                ? (!row.jsonPath && !row.customField) || (row.jsonPath && row.customField)
                : (!row.xpath && !row.customField) || (row.xpath && row.customField)
        );

        // If JSON, also check that uploadedJSONFile exists
        const hasFile = isJson ? !!this.state.uploadedJSONFile : !!this.state.uploadedXMLFile;

        if (!hasValidRow || !allRowsValid || !hasFile) {
            if (this.state.isCustomFieldMappingValid !== false) {
                this.setState({ isCustomFieldMappingValid: false });
                if (document.getElementById("validate-custom-fields-mapping"))
                    document.getElementById("validate-custom-fields-mapping").style.borderColor = "";
            }
            return false;
        }
        return true;
    };

    isMetadataMappingReady = () => {
        // Determine if JSON or XML is active
        const isJson = this.state.isJson;
        const metadataRows = isJson ? this.state.jsonMetadataMappingRows || [] : this.state.xmlMetadataMappingRows || [];
        const directionRows = isJson ? this.state.jsonDirectionMappingRows || [] : this.state.xmlDirectionMappingRows || [];
        const participantRows = isJson ? this.state.jsonParticipantMappingRows || [] : this.state.xmlParticipantMappingRows || [];

        // Metadata validation
        const hasValidMetadata = metadataRows.some(row =>
            isJson ? row.jsonPath && row.value : row.xpath && row.value
        );
        const allMetadataValid = metadataRows.every(row =>
            isJson
                ? (!row.jsonPath && !row.value) || (row.jsonPath && row.value)
                : (!row.xpath && !row.value) || (row.xpath && row.value)
        );
        if (!hasValidMetadata || !allMetadataValid) {
            if (this.state.isMetadataMappingValid !== false) {
                this.setState({ isMetadataMappingValid: false });
                if (document.getElementById("validate-metadata-mapping")) document.getElementById("validate-metadata-mapping").style.borderColor = "";
            }
            return false;
        }

        // Direction validation
        const allDirectionValid = directionRows.every(row =>
            isJson
                ? (!row.jsonKey && !row.directionValue) || (row.jsonKey && row.directionValue)
                : (!row.xmlKey && !row.directionValue) || (row.xmlKey && row.directionValue)
        );
        if (!allDirectionValid) {
            if (this.state.isMetadataMappingValid !== false) {
                this.setState({ isMetadataMappingValid: false });
                if (document.getElementById("validate-metadata-mapping")) document.getElementById("validate-metadata-mapping").style.borderColor = "";
            }
            return false;
        }

        // Participant validation
        const allParticipantValid = participantRows.every(participant =>
            Array.isArray(participant.Mappings) &&
            participant.Mappings.every(row =>
                (!row.mappingKey && !row.value) || (row.mappingKey && row.value)
            )
        );
        if (!allParticipantValid) {
            if (this.state.isMetadataMappingValid !== false) {
                this.setState({ isMetadataMappingValid: false });
                if (document.getElementById("validate-metadata-mapping")) document.getElementById("validate-metadata-mapping").style.borderColor = "";
            }
            return false;
        }

        return true;
    };
    //-------------------------------Generic xml mapping end --------------------------------//

    //--------------------------------GENERIC JSON MAPPING--------------------------------//
    handleJsonUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const text = await file.text();
        let json;
        try {
            json = JSON.parse(text);
        } catch (e) {
            toast.error("Invalid JSON file", { position: "bottom-left" });
            return;
        }
        const mappings = this.transformJsonToMappings(json);
        const customFieldKeys = Object.keys(mappings.customFieldMapping || {});
        const metadataKeys = Object.keys(mappings.MetadataMapping.MetadataMappings || {});
        const participantMappings = mappings.MetadataMapping.ParticipantMappings || [];
        const directionKeys = Object.keys(mappings.MetadataMapping.DirectionMappings || {});

        // Clear XML-related states
        this.setState({
            uploadedXmlMappings: null,
            xmlCustomFieldsMappingRows: [],
            xmlMetadataMappingRows: [],
            xmlParticipantMappingRows: [],
            xmlDirectionMappingRows: [],
            xmlTimeZone: "",
            xmlDateTimeFormat: "",
            xmlParticipantMapType: "",
            uploadedXMLFile: "",
            // Set JSON-related states
            uploadedJsonMappings: mappings,
            jsonCustomFieldsMappingRows: customFieldKeys.length > 0 ? [{ jsonPath: '', customField: '' }] : [],
            jsonMetadataMappingRows: metadataKeys.length > 0 ? [{ jsonPath: '', value: '' }] : [],
            jsonParticipantMappingRows: participantMappings.map(participant => ({
                Mappings: [{ mappingKey: undefined, value: '' }],
                ...participant
            })),
            jsonDirectionMappingRows: directionKeys.length > 0 ? [{ jsonKey: '', directionValue: '' }] : [],
            uploadedJSONFile: text,
            jsonTimeZone: "",
            jsonDateTimeFormat: "",
            jsonParticipantMapType: participantMappings.length > 1 ? "Multi" : "Single",
            jsonPostParticipantMappingRules: mappings.MetadataMapping.PostParticipantMappingRules || [{
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                ComparisonMethod: "",
                Reason: ""
            }],
            FinalDirectionMappingRule: mappings.MetadataMapping.FinalDirectionMappingRule || {
                ParticipantTargetField: "",
                MetadataFieldPath: "",
                IsCaller: false
            },
            isJson: true
        });
    };

    transformJsonToMappings = (json) => {
        // Assume the structure is { status, data: { ... } }
        const data = json.data || {};
        // Custom fields: proxy_id, capture_engine, callid
        const customFieldMapping = {
            "data.proxy_id": data.proxy_id,
            "data.capture_engine": data.capture_engine,
            "data.callid": data.callid
        };
        // Add any fields from data whose key includes "custom"
        Object.keys(data).forEach(key => {
            if (key.toLowerCase().includes("custom")) {
                customFieldMapping[`data.${key}`] = data[key];
            }
        });

        // Metadata mappings
        const MetadataMappings = {
            "data.t_start": data.t_start,
            "data.t_stop": data.t_stop,
            "data.duration": data.duration,
            "data.serviceowner": data.serviceowner,
            "data.answering": data.answering,
            "data.reason": data.reason
        };
        if (Array.isArray(data.participants)) {
            MetadataMappings["data.participants[*]"] = "Participants";
        }

        // Direction mappings

        //const DirectionMappings = {
        //    "Incoming": "Inbound",
        //    "Outgoing": "Outbound"
        //};
        const directionValues = [
            { key: "Internal", text: "Internal" },
            { key: "Inbound", text: "Inbound" },
            { key: "Outbound", text: "Outbound" },
            { key: "Incoming", text: "Incoming" },
            { key: "Outgoing", text: "Outgoing" }
        ];

        const DirectionMappings = {};
        if (data.direction !== undefined && data.direction !== null && data.direction !== "") {
            DirectionMappings["data.direction"] = data.direction;
        } else {
            directionValues.forEach(({ key }) => {
                DirectionMappings[key] = key;
            });
        }

        // PostParticipantMappingRules
        const PostParticipantMappingRules = [{
            ParticipantTargetField: "",
            MetadataFieldPath: "",
            ComparisonMethod: "",
            Reason: ""
        }];
        if (json.PostParticipantMappingRules) {
            PostParticipantMappingRules.ParticipantTargetField = json.PostParticipantMappingRules.ParticipantTargetField || "";
            PostParticipantMappingRules.MetadataFieldPath = json.PostParticipantMappingRules.MetadataFieldPath || "";
            PostParticipantMappingRules.ComparisonMethod = json.PostParticipantMappingRules.ComparisonMethod || "";
            PostParticipantMappingRules.Reason = json.PostParticipantMappingRules.Reason || "";
        }

        // FinalDirectionMappingRule
        const FinalDirectionMappingRule = {
            ParticipantTargetField: "",
            MetadataFieldPath: "",
            IsCaller: false
        };

        if (json.FinalDirectionMappingRule) {
            FinalDirectionMappingRule.ParticipantTargetField = json.FinalDirectionMappingRule.ParticipantTargetField || "";
            FinalDirectionMappingRule.MetadataFieldPath = json.FinalDirectionMappingRule.MetadataFieldPath || "";
            FinalDirectionMappingRule.IsCaller = !!json.FinalDirectionMappingRule.IsCaller;
        }
        // ParticipantMappings
        let ParticipantMappings = [];

        if (Array.isArray(data.participants)) {
            // Format 2: participants array
            data.participants.forEach((participant, idx) => {
                if (participant.party) {
                    ParticipantMappings.push({
                        Mapping: { [`data.participants.party`]: data.participants.party },
                        IsCallOwnerCheckField: null,
                        IsCallOwner: false,
                        IsCaller: false,
                        IsInternalCheckField: null
                    });
                }
            });
        } else {
            // Format 1: party_a, party_b, party_c, etc.
            Object.keys(data).forEach(key => {
                if (/^party(_[a-zA-Z0-9]+)?$/.test(key) && data[key]) {
                    ParticipantMappings.push({
                        Mapping: { [`data.${key}`]: data[key] },
                        IsCallOwnerCheckField: null,
                        IsCallOwner: false,
                        IsCaller: false,
                        IsInternalCheckField: null
                    });
                }
            });
        }

        return {
            customFieldMapping,
            MetadataMapping: {
                MetadataMappingType: "JSON",
                MetadataMappings,
                DirectionMappings,
                PostParticipantMappingRules,
                FinalDirectionMappingRule,
                ParticipantMappings,
                TimeZone: "",
                DateTimeFormat: "",
                ParticipantMapType: Array.isArray(data.participants) ? "Multi" : "Single"
            }
        };
    };

    // --- JSON Custom Field Mapping Handlers ---
    handleJsonCustomFieldsMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonCustomFieldsMappingRows];
            rows[idx][field] = value;
            return { jsonCustomFieldsMappingRows: rows };
        });
    };

    handleAddJsonCustomFieldsMappingRowUI = () => {
        this.setState(prevState => ({
            jsonCustomFieldsMappingRows: [...(prevState.jsonCustomFieldsMappingRows || []), { jsonPath: '', customField: '' }]
        }));
    };

    handleRemoveJsonCustomFieldsMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.jsonCustomFieldsMappingRows.filter((_, i) => i !== idx);
            return { jsonCustomFieldsMappingRows: rows.length > 0 ? rows : [{ jsonPath: '', customField: '' }] };
        });
    };

    // --- JSON Metadata Mapping Handlers ---
    handleJsonMetadataMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonMetadataMappingRows];
            rows[idx][field] = value;
            return { jsonMetadataMappingRows: rows };
        });
    };

    handleAddJsonMetadataMappingRowUI = () => {
        this.setState(prevState => ({
            jsonMetadataMappingRows: [...(prevState.jsonMetadataMappingRows || []), { jsonPath: '', value: '' }]
        }));
    };

    handleRemoveJsonMetadataMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.jsonMetadataMappingRows.filter((_, i) => i !== idx);
            return { jsonMetadataMappingRows: rows.length > 0 ? rows : [{ jsonPath: '', value: '' }] };
        });
    };

    // --- JSON Participant Mapping Handlers ---
    handleJsonParticipantMappingRowChange = (idx, rowIdx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonParticipantMappingRows];
            const mappings = [...rows[idx].Mappings];
            mappings[rowIdx][field] = value;
            rows[idx].Mappings = mappings;
            return { jsonParticipantMappingRows: rows };
        });
    };

    handleAddJsonParticipantMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonParticipantMappingRows];
            rows[idx].Mappings.push({ mappingKey: undefined, value: '' });
            return { jsonParticipantMappingRows: rows };
        });
    };

    handleRemoveJsonParticipantMappingRowUI = (idx, rowIdx) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonParticipantMappingRows];
            rows[idx].Mappings = rows[idx].Mappings.filter((_, i) => i !== rowIdx);
            if (rows[idx].Mappings.length === 0) rows[idx].Mappings = [{ mappingKey: undefined, value: '' }];
            return { jsonParticipantMappingRows: rows };
        });
    };

    handleJsonParticipantMappingCheckboxChange = (idx, field, checked) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonParticipantMappingRows];
            rows[idx][field] = checked;
            return { jsonParticipantMappingRows: rows };
        });
    };

    // --- JSON Direction Mapping Handlers ---
    handleJsonDirectionMappingRowChange = (idx, field, value) => {
        this.setState(prevState => {
            const rows = [...prevState.jsonDirectionMappingRows];
            rows[idx][field] = value;
            return { jsonDirectionMappingRows: rows };
        });
    };

    handleAddJsonDirectionMappingRowUI = () => {
        this.setState(prevState => ({
            jsonDirectionMappingRows: [...(prevState.jsonDirectionMappingRows || []), { jsonKey: '', directionValue: '' }]
        }));
    };

    handleRemoveJsonDirectionMappingRowUI = (idx) => {
        this.setState(prevState => {
            const rows = prevState.jsonDirectionMappingRows.filter((_, i) => i !== idx);
            return { jsonDirectionMappingRows: rows.length > 0 ? rows : [{ jsonKey: '', directionValue: '' }] };
        });
    };

    getJsonImportMappingResult = () => {
        // Convert customFieldMapping array to dictionary
        let customFieldMappingDict = {};
        let customFieldMappingArr = this.state.jsonCustomFieldsMappingRows;
        if (
            Array.isArray(customFieldMappingArr) &&
            customFieldMappingArr.length === 1 &&
            (!customFieldMappingArr[0].jsonPath || customFieldMappingArr[0].jsonPath === '') &&
            (!customFieldMappingArr[0].customField || customFieldMappingArr[0].customField === '')
        ) {
            customFieldMappingArr = [];
        }
        customFieldMappingArr.forEach(({ jsonPath, customField }) => {
            if (jsonPath && customField) {
                customFieldMappingDict[jsonPath] = customField;
            }
        });

        // Convert MetadataMappings array to dictionary
        let MetadataMappingsDict = {};
        let MetadataMappingsArr = this.state.jsonMetadataMappingRows;
        if (
            Array.isArray(MetadataMappingsArr) &&
            MetadataMappingsArr.length === 1 &&
            (!MetadataMappingsArr[0].jsonPath || MetadataMappingsArr[0].jsonPath === '') &&
            (!MetadataMappingsArr[0].value || MetadataMappingsArr[0].value === '')
        ) {
            MetadataMappingsArr = [];
        }
        MetadataMappingsArr.forEach(({ jsonPath, value }) => {
            if (jsonPath && value) {
                MetadataMappingsDict[jsonPath] = value;
            }
        });

        // Convert DirectionMappings array to dictionary
        let DirectionMappingsDict = {};
        let DirectionMappingsArr = this.state.jsonDirectionMappingRows;
        if (
            Array.isArray(DirectionMappingsArr) &&
            DirectionMappingsArr.length === 1 &&
            (!DirectionMappingsArr[0].jsonKey || DirectionMappingsArr[0].jsonKey === '') &&
            (!DirectionMappingsArr[0].directionValue || DirectionMappingsArr[0].directionValue === '')
        ) {
            DirectionMappingsArr = [];
        }
        DirectionMappingsArr.forEach(({ jsonKey, directionValue }) => {
            if (jsonKey && directionValue) {
                DirectionMappingsDict[jsonKey] = directionValue;
            }
        });

        // ParticipantMappings: array, but Mapping inside each participant is a dictionary
        let ParticipantMappings = (this.state.jsonParticipantMappingRows || []).map(participant => {
            let mappingsArr = participant.Mappings;
            let mappingsDict = {};
            if (
                Array.isArray(mappingsArr) &&
                mappingsArr.length === 1 &&
                (!mappingsArr[0].mappingKey || mappingsArr[0].mappingKey === '') &&
                (!mappingsArr[0].value || mappingsArr[0].value === '')
            ) {
                mappingsArr = [];
            }
            mappingsArr.forEach(({ mappingKey, value }) => {
                if (mappingKey && value) {
                    mappingsDict[mappingKey] = value;
                }
            });
            // Copy participant, but replace Mappings array with Mapping dictionary
            const { Mappings, ...rest } = participant;
            return {
                ...rest,
                Mapping: mappingsDict
            };
        });

        // Compose the final structure
        return {
            customFieldMapping: customFieldMappingDict,
            MetadataMapping: {
                MetadataMappings: MetadataMappingsDict,
                MetadataMappingType: "JSON",
                DirectionMappings: DirectionMappingsDict,
                ParticipantMappings,
                TimeZone: this.state.jsonTimeZone,
                DateTimeFormat: this.state.jsonDateTimeFormat,
                ParticipantMapType: this.state.jsonParticipantMapType,
                PostParticipantMappingRules: this.state.jsonPostParticipantMappingRules,
                FinalDirectionMappingRule: this.state.FinalDirectionMappingRule

            }
        };
    };

    //--------------------------------Generic json mapping end----------------------------------//
    render() {

        return (
            <MyContext.Consumer>
                {(context) => (

                    <Stack vertical>
                        {/* name */}
                        <TextField type={"text"}
                            label={context.getTranslation("configuration", "jobName")}
                            value={this.state.name}
                            onChange={(event, newValue) => {
                                this.setState({ name: newValue });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />

                        <Toggle
                            defaultChecked={this.state.enabled}
                            label={context.getTranslation("settings", "enabled")}
                            onText={context.getTranslation("settings", "on")}
                            offText={context.getTranslation("settings", "off")}
                            onChange={(ev, checked) => {
                                this.setState({
                                    enabled: checked,
                                    updated: true
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />

                        <Label alignContent="start">{context.getTranslation("configuration", "interval")}</Label>

                        <ChoiceGroup
                            selectedKey={this.state.intervalType}
                            style={{ width: "200px" }}
                            options={[
                                {
                                    key: 'OneTime',
                                    text: context.getTranslation("configuration", "single"),
                                    'data-automation-id': 'auto1',
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                },
                                {
                                    key: 'Periodical',
                                    text: context.getTranslation("configuration", "periodical"),
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                }
                            ]}
                            onChange={(event, newValue) => {
                                this.setState({
                                    intervalType: newValue.key,
                                    intervalMinute: newValue.key === 'Periodical' ? 30 : 0,
                                    updated: true
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />

                        {(this.state.intervalType == "Periodical" && this.state.importType !== "NeoTransfer") &&
                            <Stack.Item>
                                <Label>{context.getTranslation("configuration", "startTime")}</Label>

                                <DateTimePicker
                                    locale={this.props.authorization.locale}
                                    calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}

                                    firstDayOfWeek={1}
                                    value={this.state.jobStartTime ? new Date(this.state.jobStartTime) : null}
                                    onChange={(date) => {
                                        if (date === null) {
                                            this.setState({ jobStartTime: null });
                                            return;
                                        }
                                        let parsedDate = new Date(date);
                                        if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                            parsedDate = new Date("0001-01-01T00:00:00Z")
                                        }
                                        else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                            parsedDate = new Date("9999-12-31T23:59:59Z")
                                        }
                                        this.setState({
                                            jobStartTime: parsedDate
                                        });
                                    }
                                    }
                                    minDate={new Date("0001-01-01T00:00:00Z")}
                                    maxDate={new Date("9999-12-31T23:59:59Z")}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />

                            </Stack.Item>
                        }
                        {(this.state.intervalType == "Periodical" && this.state.importType !== "NeoTransfer") &&
                            <Stack>
                                <Stack.Item>
                                    <Label>{context.getTranslation("configuration", "cycle")}</Label>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}
                                            label={context.getTranslation("configuration", "cycleMonth")}
                                            value={this.state.intervalMonth}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalMonth: newValue
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}

                                            label={context.getTranslation("configuration", "cycleDay")}
                                            value={this.state.intervalDay}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalDay: newValue
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={0}

                                            label={context.getTranslation("configuration", "cycleHour")}
                                            value={this.state.intervalHour}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalHour: newValue,
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                    <div style={{ diplay: "flex" }}>
                                        <TextField
                                            name="CycleTime"
                                            type="Number"
                                            min={this.state.importType === "Aiphoria" ? 60 : 30}
                                            step="30"
                                            onKeyPress={(e) => e.preventDefault()}
                                            label={context.getTranslation("configuration", "cycleMinute")}
                                            value={this.state.intervalMinute}
                                            onChange={(event, newValue) => {
                                                if (newValue < 0)
                                                    newValue = 0;
                                                this.setState({
                                                    intervalMinute: newValue
                                                })
                                            }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                        />

                                    </div>

                                </Stack.Item>
                            </Stack>
                        }

                        <br />
                        <hr />

                        <ComboBox
                            style={{ width: "300px" }}
                            placeholder="Select an option"
                            selectedKey={this.state.importType}
                            label={context.getTranslation("configuration", "importType")}
                            onChange={(ev, newVal) => {
                                const newRetentionTimeSource = ["Genesys", "Numonix", "Kerv", "SmartNumbers", "Verba", "Abelia", "DC"].includes(newVal.key) ? false : this.state.sourceTtlEnabled;

                                //change mapping type to UsersToUsers because UsersToComplianceOfficer is not available for them
                                //and change to UsersToComplianceOfficer for Verint because UsersToUsers is not available to it and this can be applied then tu future types
                                const newMappingType = ["Verint"].includes(newVal.key) ? "UsersToComplianceOfficer" : ["Kerv", "Abelia", "NeoTransfer", "DC", "Recordia"].includes(newVal.key) ? 'UsersToUsers' : this.state.mappingType;
                                this.setState({
                                    importType: newVal.key,
                                    sourceTtlEnabled: newRetentionTimeSource,
                                    isValidUUID: true,
                                    mappingType: newMappingType,
                                    updated: true,
                                    storageConnectionString: "",
                                    storageContainerName: "",
                                    storageRootDirectory: "",
                                    intervalMinute: newVal.key === "Aiphoria" ? 60 : this.state.intervalMinute,
                                    createUnmixedEnhancement: ["Neo", "NeoTransfer"].includes(newVal.key) ? true : false

                                });
                            }}
                            options={[{
                                key: "Neo",
                                text: "EVOIPneo"
                            },
                            {
                                key: "RedBox",
                                text: "RedBox",
                            },
                            {
                                key: "ASCRI",
                                text: "ASC RI",
                            },
                            {
                                key: "Numonix",
                                text: "Numonix",

                            },
                            {
                                key: "Genesys",
                                text: "Genesys",
                            },
                            {
                                key: "Nice",
                                text: "Nice",
                            },
                            {
                                key: "API8x8",
                                text: "API 8x8",
                            },
                            {
                                key: "Verba",
                                text: "Verba",
                            },
                            {
                                key: "Kerv",
                                text: "Kerv",
                            },
                            {
                                key: "SmartNumbers",
                                text: "SmartNumbers",
                            },
                            {
                                key: "Dubber",
                                text: "Dubber",
                            },
                            {
                                key: "Abelia",
                                text: "Abelia",
                            },
                            {
                                key: "NeoTransfer",
                                text: "Neo Transfer",
                            },
                            {
                                key: "DC",
                                text: "Neo Download Client",
                            },
                            {
                                key: "Recordia",
                                text: "Recordia",
                            },
                            {
                                key: "Verint",
                                text: "Verint",
                            },
                            {
                                key: "Crealog",
                                text: "Crealog",
                            },
                            {
                                key: "Aiphoria",
                                text: "Aiphoria Focus API",
                            },
                            {
                                key: "Generic",
                                text: "Generic",
                            },
                            {
                                key: "DamovoVerint",
                                text: "Damovo Verint",
                            }]
                            }
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />
                        {["Genesys", "Numonix", "Kerv", "SmartNumbers", "Recordia"].includes(this.state.importType) && <Stack.Item style={{ marginTop: "10px" }}>
                            <div id="clickable-area">
                                <input type="file" onChange={this.onFileChange} id="file-btn" disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false} />
                                <div className="upload-button"><span>{this.state.hasSftpKey ? context.getTranslation("common", "updateFile") : context.getTranslation("common", "uploadFile")}</span>
                                </div><p id="clickable-area-text">{this.state.sftpPrivateKeyUpload
                                    ? <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "20px" }}></i>
                                    : context.getTranslation("common", "noFileSelected")} &nbsp;</p>
                            </div>
                        </Stack.Item>}

                        {this.state.importType === "Genesys" && <Stack.Item style={{ marginTop: "10px" }}>
                            <Label>{context.getTranslation("configuration", "importOnlyForUserGroup")}</Label>
                            <UserPicker
                                user={this.state.userIds}

                                fc={(user) => {
                                    this.setState({
                                        userIds: user
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                        </Stack.Item>}

                        {(this.state.importType === "API8x8" || this.state.importType === "Aiphoria") && <Stack.Item>
                            <Label>{context.getTranslation("configuration", "callStartTime")}</Label>

                            <DateTimePicker
                                locale={this.props.authorization.locale}
                                calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}

                                firstDayOfWeek={1}
                                value={this.state.callStartTime ? new Date(this.state.callStartTime) : null}
                                onChange={(date) => {
                                    if (date === null) {
                                        this.setState({
                                            callStartTime: null,
                                            callDateError: ''
                                        });
                                        return;
                                    }
                                    let parsedDate = new Date(date);
                                    if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                        parsedDate = new Date("0001-01-01T00:00:00Z")
                                    }
                                    else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                        parsedDate = new Date("9999-12-31T23:59:59Z")
                                    }

                                    if (this.state.callEndTime && parsedDate > new Date(this.state.callEndTime)) {
                                        this.setState({
                                            callDateError: "startDateBeforeEndDate",
                                            callStartTime: null,
                                        });
                                    } else {
                                        this.setState({
                                            callStartTime: parsedDate,
                                            callDateError: ''
                                        });
                                    }
                                }
                                }
                                minDate={new Date("0001-01-01T00:00:00Z")}
                                maxDate={new Date("9999-12-31T23:59:59Z")}
                            />

                            <Label>{context.getTranslation("configuration", "callEndTime")}</Label>

                            <DateTimePicker
                                locale={this.props.authorization.locale}
                                calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}

                                firstDayOfWeek={1}
                                value={this.state.callEndTime ? new Date(this.state.callEndTime) : null}
                                onClockOpen={() => this.setState({ callEndIsClockOpen: true })}
                                onClockClose={() => this.setState({ callEndIsClockOpen: false })}
                                onChange={(date) => {
                                    if (date === null) {
                                        this.setState({
                                            callEndTime: null,
                                            callDateError: ''
                                        });
                                        return;
                                    }
                                    let parsedDate = new Date(date);
                                    if (parsedDate < new Date("0001-01-01T00:00:00Z")) {
                                        parsedDate = new Date("0001-01-01T00:00:00Z")
                                    }
                                    else if (parsedDate > new Date("9999-12-31T23:59:59Z")) {
                                        parsedDate = new Date("9999-12-31T23:59:59Z")
                                    }

                                    // Apply 23:59:59 when selecting from calendar (clock not open)
                                    if (!this.state.callEndIsClockOpen) {
                                        parsedDate.setHours(23, 59, 59, 999);
                                    }

                                    if (this.state.callStartTime && parsedDate < new Date(this.state.callStartTime)) {
                                        this.setState({
                                            callDateError: "endDateBeforeStartDate",
                                            callEndTime: null,
                                        });
                                    } else {
                                        this.setState({
                                            callEndTime: parsedDate,
                                            callDateError: ''
                                        });
                                    }
                                }
                                }
                                minDate={new Date("0001-01-01T00:00:00Z")}
                                maxDate={new Date("9999-12-31T23:59:59Z")}
                            />
                            {this.state.callDateError && (
                                <Text style={{ color: '#a80000' }}>{context.getTranslation("filterPanel", this.state.callDateError)}</Text>
                            )}
                        </Stack.Item>}


                        {/*-----------------DamovoVerint CSV mapping file upload-----------------*/}
                        {this.state.importType === "DamovoVerint" && <>
                            <br />
                            <Label>{context.getTranslation("common", "uploadFile")} (CSV)</Label>
                            <UploadMappingFile
                                apol={this.props.apol}
                                authorization={this.props.authorization}
                                idFiles="mappingFileInput"
                                idResult="mappingFileResult"
                                idError="mappingFileError"
                                fileBtnText={""}
                                disabled={(this.props.data !== null && this.props.data.isArchived)}
                                onFileUploaded={(fileName, baseUrl) => {
                                    const entry = baseUrl + "/" + fileName;
                                    this.setState(prevState => ({
                                        deletedFilesFromMappingFiles: [...prevState.deletedFilesFromMappingFiles, ...prevState.mappingFiles],
                                        mappingFiles: [entry]
                                    }));
                                }}
                            />
                            {this.state.mappingFiles.length > 0 && (
                                <div>
                                    <Label>Uploaded Files</Label>
                                    {this.state.mappingFiles.map((entry, idx) => {
                                        const displayName = entry.includes("/") ? entry.split("/").pop() : entry;
                                        return (
                                            <Stack horizontal key={idx} tokens={{ childrenGap: 8 }} verticalAlign="center" style={{ marginBottom: 4 }}>
                                                <Text>{displayName}</Text>
                                            </Stack>
                                        );
                                    })}
                                </div>
                            )}
                            <br />
                            <hr />
                        </>}
                        {/*------------------End DamovoVerint CSV mapping file upload-----------------*/}

                        <br />
                        {this.state.importType !== "NeoTransfer" &&
                            <Label>{context.getTranslation("configuration", "storage")}</Label>
                        }

                        {/* import connection string */}
                        {this.state.importType !== "NeoTransfer" && <Stack.Item>


                            <TextField label={context.getTranslation("configuration", "storageConnectionString")}
                                id="storageConnectionString"
                                value={this.state.storageConnectionString}
                                onChange={(event, newValue) => {
                                    this.setState({ storageConnectionString: newValue, validateStorageConnectionString: "", storageConnectionStringChanged: true });

                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                placeholder={this.storageConnectionStringPlaceHolder()}
                            />

                            <TextField label={context.getTranslation("configuration", "storageContainerName")}
                                id="storageContainerName"
                                value={this.state.storageContainerName}
                                onChange={(event, newValue) => {
                                    this.setState({ storageContainerName: newValue });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                            <span id="storageConnectionStringError" style={{ color: "red" }}></span>
                            <br />
                            <DefaultButton
                                id="checkBtn"
                                text={<MyContext.Consumer>{(context) => <> {context.getTranslation("dashboard", "checkValidity")}</>}</MyContext.Consumer>}
                                onClick={(event) => {
                                    this.checkStorageConnectionString();
                                }}
                                disabled={this.state.validateStorageConnectionString == "pending" || (this.state.storageConnectionString === "******" && !this.state.storageConnectionStringChanged)}
                            />
                            {this.state.importType !== "Neo" &&
                                < TextField label={context.getTranslation("configuration", "storageRootDirectory")}
                                    value={this.state.storageRootDirectory}
                                    onChange={(event, newValue) => {
                                        this.setState({ storageRootDirectory: newValue });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            }
                        </Stack.Item>
                        }
                        {this.state.importType === "NeoTransfer" &&
                            <Stack.Item>

                                <TextField label={context.getTranslation("configuration", "transferId")}
                                    value={this.state.transferId}
                                    onChange={this.handleTransferIdChange}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                    errorMessage={!this.state.isValidUUID ? context.getTranslation("configuration", "errorNewTransfer") : ""}
                                    placeholder={context.getTranslation("configuration", "newTransfer")}
                                />
                                {this.props.data !== null &&
                                    <DefaultButton
                                        onClick={this.downloadNeoTransferFile}
                                        text={context.getTranslation("configuration", this.state.downloadNeoTransferTextBtn)}
                                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        style={{ marginTop: "10px" }}
                                    />}

                            </Stack.Item>
                        }
                        <br />
                        <hr />
                        {!["Genesys", "Numonix", "Kerv", "SmartNumbers", "Verba", "Abelia", "DC", "NeoTransfer"].includes(this.state.importType) && <>

                            <Label>{context.getTranslation("configuration", "retentionTimeSource")}</Label>
                            <Toggle
                                defaultChecked={this.state.sourceTtlEnabled}
                                onText={context.getTranslation("settings", "on")}
                                offText={context.getTranslation("settings", "off")}
                                onChange={(ev, checked) => {
                                    this.setState({
                                        sourceTtl: checked ? 1 : -1,
                                        sourceTtlEnabled: checked,
                                        updated: true
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                            {this.state.sourceTtlEnabled &&
                                < TextField
                                    value={this.state.sourceTtl}
                                    type="Number"
                                    label={context.getTranslation("configuration", "retentionTimeSourceDays")}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            sourceTtl: newValue,
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />}
                        </>}

                        {true && < TextField
                            value={this.state.targetTtl}
                            type="Number"
                            label={context.getTranslation("configuration", "retentionTimeTargetDays")}
                            onChange={(event, newValue) => {
                                this.setState({
                                    targetTtl: newValue,
                                });
                            }}
                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />}
                        <br />
                        <hr />


                        {/*----------------------------Generic metadata mapping-----------------*/}

                        {this.state.importType === "Generic" && <>
                            <Label>{context.getTranslation("common", "uploadFile")}</Label>
                            <input
                                type="file"
                                accept=".xml,.json"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file && file.name.endsWith('.json')) {
                                        this.handleJsonUpload(e);
                                    } else {
                                        this.handleXmlUpload(e);
                                    }
                                }}
                                style={{ marginBottom: 16 }} />

                            <div>
                                {/*custom field mapping*/}

                                {/*XML custom field mapping*/}
                                {this.state.uploadedXmlMappings && (
                                    <div>
                                        <Label>{context.getTranslation("configuration", "customFieldMapping")}</Label>
                                        {(this.state.xmlCustomFieldsMappingRows || []).map((row, idx) => {
                                            const allXPaths = Object.keys(this.state.uploadedXmlMappings.customFieldMapping || {});
                                            const allCustomFields = (this.props.customfieldsdata || []).map(f => ({ key: f.id, text: f.fieldName }));
                                            const selectedXPaths = (this.state.xmlCustomFieldsMappingRows || []).map(r => r.xpath);
                                            const selectedCustomFields = (this.state.xmlCustomFieldsMappingRows || []).map(r => r.customField);
                                            const availableXPaths = allXPaths.filter(opt => !selectedXPaths.includes(opt) || opt === row.xpath);
                                            const availableCustomFields = allCustomFields.filter(opt => !selectedCustomFields.includes(opt.key) || opt.key === row.customField);
                                            const xpathValue = row.xpath ? this.state.uploadedXmlMappings.customFieldMapping[row.xpath] : '';
                                            const canAddMoreRows = this.state.xmlCustomFieldsMappingRows.length < allXPaths.length && this.state.xmlCustomFieldsMappingRows.length < allCustomFields.length;
                                            return (
                                                <div key={idx}>
                                                    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                        <ComboBox
                                                            label={idx === 0 ? "XPath" : undefined}
                                                            selectedKey={row.xpath}
                                                            options={availableXPaths.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleXmlCustomFieldsMappingRowChange(idx, 'xpath', option.key)}
                                                            placeholder="Select XPath"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <ComboBox
                                                            label={idx === 0 ? "Custom Field" : undefined}
                                                            selectedKey={row.customField}
                                                            options={availableCustomFields}
                                                            onChange={(_, option) => this.handleXmlCustomFieldsMappingRowChange(idx, 'customField', option.key)}
                                                            placeholder="Select Custom Field"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <IconButton
                                                            iconProps={{ iconName: "Delete" }}
                                                            title="Remove"
                                                            ariaLabel="Remove"
                                                            onClick={() => this.handleRemoveXmlCustomFieldsMappingRowUI(idx)}
                                                            disabled={this.state.xmlCustomFieldsMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                        />
                                                        {idx === this.state.xmlCustomFieldsMappingRows.length - 1 && canAddMoreRows && (
                                                            <IconButton
                                                                iconProps={{ iconName: "Add" }}
                                                                title="Add"
                                                                ariaLabel="Add"
                                                                onClick={this.handleAddXmlCustomFieldsMappingRowUI}
                                                                disabled={this.props.data !== null && this.props.data.isArchived || !row.xpath}
                                                            />
                                                        )}
                                                    </Stack>
                                                    {row.xpath && this.state.uploadedXMLFile && (
                                                        <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                            Value: {xpathValue}
                                                        </Text>
                                                    )}
                                                </div>
                                            );
                                        })}

                                        {this.state.uploadedXMLFile &&
                                            <DefaultButton
                                                id="validate-custom-fields-mapping"
                                                onClick={this.validateCustomFieldImport}
                                                text="Validate Custom Field Mapping"
                                                disabled={!this.isCustomFieldMappingReady()} />
                                        }
                                    </div>
                                )}

                            </div>


                            <div>
                                {/*metadata mapping*/}

                                {/*XML Metadata mapping*/}

                                {this.state.uploadedXmlMappings && (<>
                                    <div>
                                        <Separator />
                                        <Label>{context.getTranslation("configuration", "metadataMapping")}</Label>
                                        {(this.state.xmlMetadataMappingRows || []).map((row, idx) => {
                                            const allXPaths = Object.keys(this.state.uploadedXmlMappings.MetadataMapping.MetadataMappings || {});
                                            const predefinedValues = [
                                                "ScenarioId",
                                                "CallId",
                                                "Header",
                                                "ConversationType (Direction)",
                                                "CallStart",
                                                "CallEnd",
                                                "Duration",
                                                "Participants",
                                                "TTL",
                                            ];
                                            const selectedXPaths = (this.state.xmlMetadataMappingRows || []).map(r => r.xpath);
                                            const selectedValues = (this.state.xmlMetadataMappingRows || []).map(r => r.value);
                                            const availableXPaths = allXPaths.filter(opt => !selectedXPaths.includes(opt) || opt === row.xpath);
                                            const availableValues = predefinedValues.filter(opt => !selectedValues.includes(opt) || opt === row.value);
                                            const xpathValue = row.xpath ? this.state.uploadedXmlMappings.MetadataMapping.MetadataMappings[row.xpath] : '';
                                            const canAddMoreRows = this.state.xmlMetadataMappingRows.length < allXPaths.length && this.state.xmlMetadataMappingRows.length < predefinedValues.length;


                                            return (
                                                <div key={idx}>
                                                    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                        <ComboBox
                                                            label={idx === 0 ? "XPath" : undefined}
                                                            selectedKey={row.xpath}
                                                            options={availableXPaths.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleMetadataMappingRowChange(idx, 'xpath', option.key)}
                                                            placeholder="Select XPath"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <ComboBox
                                                            label={idx === 0 ? "Value" : undefined}
                                                            selectedKey={row.value}
                                                            options={availableValues.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleMetadataMappingRowChange(idx, 'value', option.key)}
                                                            placeholder="Select Value"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <IconButton
                                                            iconProps={{ iconName: "Delete" }}
                                                            title="Remove"
                                                            ariaLabel="Remove"
                                                            onClick={() => this.handleRemoveMetadataMappingRowUI(idx)}
                                                            disabled={this.state.xmlMetadataMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                        />
                                                        {idx === this.state.xmlMetadataMappingRows.length - 1 && canAddMoreRows && (
                                                            <IconButton
                                                                iconProps={{ iconName: "Add" }}
                                                                title="Add"
                                                                ariaLabel="Add"
                                                                onClick={this.handleAddMetadataMappingRowUI}
                                                                disabled={this.props.data !== null && this.props.data.isArchived || !row.xpath}
                                                            />
                                                        )}
                                                    </Stack>
                                                    {row.xpath && this.state.uploadedXMLFile && (
                                                        <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                            Value: {xpathValue}
                                                        </Text>
                                                    )}
                                                </div>
                                            );




                                        })}

                                    </div>

                                    {/*----------------------------Participant mapping-----------------*/}
                                    {Array.isArray(this.state.uploadedXmlMappings?.MetadataMapping?.ParticipantMappings) &&
                                        this.state.uploadedXmlMappings.MetadataMapping.ParticipantMappings.length > 0 && (
                                            <div>
                                                <Separator />
                                                <Label>{context.getTranslation("configuration", "participantDataMapping")}</Label>
                                                {this.state.xmlParticipantMappingRows.map((participantRow, idx) => {
                                                    // Get the Mapping object from uploadedXmlMappings for this participant
                                                    const mappingObj =
                                                        this.state.uploadedXmlMappings.MetadataMapping.ParticipantMappings[idx]?.Mapping || {};

                                                    // All possible mapping keys (the xpaths)
                                                    const mappingEntries = Object.entries(mappingObj);
                                                    const mappingXPathsOrKeys = mappingEntries.map(([key, entry]) => {
                                                        // If entry is an object and has an xpath, use it; otherwise, use the key itself
                                                        return (entry && typeof entry === 'object' && entry.xpath) ? entry.xpath : key;
                                                    });


                                                    // Device display name options
                                                    const deviceDisplayNameOptions = [
                                                        { key: 'DeviceDisplayName', text: 'DeviceDisplayName' },
                                                        { key: 'DisplayName', text: 'DisplayName' }
                                                    ];

                                                    const checkboxFieldsRow1 = ['IsCaller', 'IsCalled', 'IsCallOwner'];

                                                    return (
                                                        <div key={idx} style={{ marginBottom: 16, border: '1px solid #eee', padding: 3 }}>
                                                            <Label>{context.getTranslation("configuration", "participant") + ' ' + (idx + 1)}</Label>
                                                            {participantRow.Mappings.map((row, mIdx) => {
                                                                // Selected mapping keys in UI
                                                                const selectedKeys = participantRow.Mappings.map(r => r.mappingKey);

                                                                // Available mapping keys for dropdown (avoid duplicates except current)
                                                                const availableMappingKeys = mappingXPathsOrKeys
                                                                    .filter(opt => !selectedKeys.includes(opt) || opt === row.mappingKey)
                                                                    .map(opt => ({
                                                                        key: opt,
                                                                        text: opt // opt is always a string (the xpath)
                                                                    }));

                                                                // Find the mapping entry by xpath or key
                                                                const matchedEntry = mappingEntries.find(([key, entry]) => {
                                                                    const entryXpath = (entry && typeof entry === 'object' && entry.xpath) ? entry.xpath : key;
                                                                    return entryXpath === row.mappingKey;
                                                                });
                                                                const mappingValue = matchedEntry
                                                                    ? (typeof matchedEntry[1] === 'object' ? matchedEntry[1].value : matchedEntry[1] || '')
                                                                    : '';

                                                                return (
                                                                    <div key={mIdx}>
                                                                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                                            <ComboBox
                                                                                label={mIdx === 0 ? "Mapping Key" : undefined}
                                                                                selectedKey={row.mappingKey}
                                                                                options={availableMappingKeys}
                                                                                onChange={(_, option) => this.handleParticipantMappingRowChange(idx, mIdx, 'mappingKey', option.key)}
                                                                                placeholder="Select Mapping Key"
                                                                                style={{ width: 250 }}
                                                                                disabled={this.props.data !== null && this.props.data.isArchived}
                                                                            />
                                                                            <ComboBox
                                                                                label={mIdx === 0 ? "Value" : undefined}
                                                                                selectedKey={row.value}
                                                                                options={deviceDisplayNameOptions}
                                                                                onChange={(_, option) => this.handleParticipantMappingRowChange(idx, mIdx, 'value', option.key)}
                                                                                placeholder="Select Value"
                                                                                style={{ width: 250 }}
                                                                                disabled={this.props.data !== null && this.props.data.isArchived}
                                                                            />
                                                                            <IconButton
                                                                                iconProps={{ iconName: "Delete" }}
                                                                                title="Remove"
                                                                                ariaLabel="Remove"
                                                                                onClick={() => this.handleRemoveParticipantMappingRowUI(idx, mIdx)}
                                                                                disabled={participantRow.Mappings.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                                            />
                                                                            {mIdx === participantRow.Mappings.length - 1 && (
                                                                                <IconButton
                                                                                    iconProps={{ iconName: "Add" }}
                                                                                    title="Add"
                                                                                    ariaLabel="Add"
                                                                                    onClick={() => this.handleAddParticipantMappingRowUI(idx)}
                                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                                />
                                                                            )}
                                                                        </Stack>
                                                                        {row.mappingKey && this.state.uploadedXMLFile && (
                                                                            <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                                                Value: {mappingValue}
                                                                            </Text>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                            <Stack horizontal tokens={{ childrenGap: 16 }} style={{ marginBottom: 4 }}>
                                                                {checkboxFieldsRow1.map(field => (
                                                                    <Checkbox
                                                                        key={field}
                                                                        label={field}
                                                                        checked={participantRow[field] === true}
                                                                        onChange={(_, checked) => this.handleParticipantMappingCheckboxChange(idx, field, checked)}
                                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                                    />
                                                                ))}
                                                            </Stack>
                                                            <Stack tokens={{ childrenGap: 16 }}>
                                                                <TextField
                                                                    label="IsCallOwnerCheckField"
                                                                    value={participantRow.IsCallOwnerCheckField || ""}
                                                                    onChange={(_, newValue) => {
                                                                        const rows = [...this.state.xmlParticipantMappingRows];
                                                                        rows[idx].IsCallOwnerCheckField = newValue;
                                                                        this.setState({ xmlParticipantMappingRows: rows });
                                                                    }}
                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                    style={{ width: 180 }}
                                                                />
                                                            </Stack>
                                                            <Stack tokens={{ childrenGap: 8 }}>
                                                                <Label>IsInternalCheckField</Label>
                                                                {(() => {
                                                                    // Convert IsInternalCheckField to array if needed
                                                                    const entries = Array.isArray(participantRow.IsInternalCheckField)
                                                                        ? participantRow.IsInternalCheckField
                                                                        : Object.entries(participantRow.IsInternalCheckField).map(([xmlFieldName, logicalProperty]) => ({ xmlFieldName, logicalProperty }));

                                                                    const displayEntries = entries.length > 0 ? entries : [{ xmlFieldName: "", logicalProperty: "" }];

                                                                    return displayEntries.map((entry, entryIdx, arr) => (
                                                                        <Stack
                                                                            horizontal
                                                                            tokens={{ childrenGap: 8 }}
                                                                            key={entryIdx}
                                                                            verticalAlign="end"
                                                                            style={{ width: 470, justifyContent: "space-between", marginBottom: 8 }}
                                                                        >
                                                                            <Stack horizontal tokens={{ childrenGap: 4 }} style={{ flexGrow: 1 }}>
                                                                                <TextField
                                                                                    label="Field"
                                                                                    value={entry.xmlFieldName}
                                                                                    onChange={(_, newValue) => {
                                                                                        const updatedArray = [...displayEntries];
                                                                                        updatedArray[entryIdx] = { ...updatedArray[entryIdx], xmlFieldName: newValue };
                                                                                        // Convert array to object
                                                                                        const updatedObj = {};
                                                                                        updatedArray.forEach(({ xmlFieldName, logicalProperty }) => {
                                                                                            if (xmlFieldName) updatedObj[xmlFieldName] = logicalProperty;
                                                                                        });
                                                                                        const rows = [...this.state.xmlParticipantMappingRows];
                                                                                        rows[idx].IsInternalCheckField = updatedObj;
                                                                                        this.setState({ xmlParticipantMappingRows: rows });
                                                                                    }}
                                                                                    style={{ width: 250 }}
                                                                                />
                                                                                <ComboBox
                                                                                    label="Value"
                                                                                    selectedKey={entry.logicalProperty}
                                                                                    options={userProperties.map(p => ({ key: p, text: p }))}
                                                                                    onChange={(_, option) => {
                                                                                        const updatedArray = [...displayEntries];
                                                                                        updatedArray[entryIdx] = { ...updatedArray[entryIdx], logicalProperty: option.key };
                                                                                        const updatedObj = {};
                                                                                        updatedArray.forEach(({ xmlFieldName, logicalProperty }) => {
                                                                                            if (xmlFieldName) updatedObj[xmlFieldName] = logicalProperty;
                                                                                        });
                                                                                        const rows = [...this.state.xmlParticipantMappingRows];
                                                                                        rows[idx].IsInternalCheckField = updatedObj;
                                                                                        this.setState({ xmlParticipantMappingRows: rows });
                                                                                    }}
                                                                                    style={{ width: 250 }}
                                                                                />
                                                                            </Stack>
                                                                            <Stack horizontal tokens={{ childrenGap: 4 }}>
                                                                                <IconButton
                                                                                    iconProps={{ iconName: "Delete" }}
                                                                                    title="Remove"
                                                                                    ariaLabel="Remove"
                                                                                    onClick={() => {
                                                                                        let updated = [...displayEntries];
                                                                                        updated.splice(entryIdx, 1);
                                                                                        if (updated.length === 0) updated = [{ xmlFieldName: "", logicalProperty: "" }];
                                                                                        const rows = [...this.state.xmlParticipantMappingRows];
                                                                                        rows[idx].IsInternalCheckField = updated;
                                                                                        this.setState({ xmlParticipantMappingRows: rows });
                                                                                    }}
                                                                                />
                                                                                {entryIdx === arr.length - 1 && (
                                                                                    <IconButton
                                                                                        iconProps={{ iconName: "Add" }}
                                                                                        title="Add"
                                                                                        ariaLabel="Add"
                                                                                        onClick={() => {
                                                                                            const updated = [...displayEntries, { xmlFieldName: "", logicalProperty: "" }];
                                                                                            const rows = [...this.state.xmlParticipantMappingRows];
                                                                                            rows[idx].IsInternalCheckField = updated;
                                                                                            this.setState({ xmlParticipantMappingRows: rows });
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </Stack>
                                                                        </Stack>
                                                                    ));
                                                                })()}
                                                            </Stack>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                    {/*Direction Mapping*/}
                                    {this.state.uploadedXmlMappings.MetadataMapping.DirectionMappings && (
                                        <div>
                                            <Separator />

                                            {(this.state.xmlDirectionMappingRows || []).map((row, idx) => {
                                                <Label>{context.getTranslation("configuration", "directionMapping")}</Label>
                                                const directionKeys = Object.keys(this.state.uploadedXmlMappings.MetadataMapping.DirectionMappings || {});
                                                const directionValues = [
                                                    { key: "Internal", text: "Internal" },
                                                    { key: "Inbound", text: "Inbound" },
                                                    { key: "Outbound", text: "Outbound" },
                                                    { key: "Incoming", text: "Incoming" },
                                                    { key: "Outgoing", text: "Outgoing" }
                                                ];
                                                const selectedKeys = (this.state.xmlDirectionMappingRows || []).map(r => r.xmlKey);
                                                const availableKeys = directionKeys.filter(opt => !selectedKeys.includes(opt) || opt === row.xmlKey);
                                                const canAddMoreRows = this.state.xmlDirectionMappingRows.length < directionKeys.length && this.state.xmlDirectionMappingRows.length < directionValues.length;
                                                return (
                                                    <div key={idx}>
                                                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                            <ComboBox
                                                                label={idx === 0 ? "XML Direction" : undefined}
                                                                selectedKey={row.xmlKey}
                                                                options={availableKeys.map(opt => ({ key: opt, text: opt }))}
                                                                onChange={(_, option) => this.handleDirectionMappingRowChange(idx, 'xmlKey', option.key)}
                                                                placeholder="Select XML Direction"
                                                                style={{ width: 250 }}
                                                                disabled={this.props.data !== null && this.props.data.isArchived}
                                                            />
                                                            <ComboBox
                                                                label={idx === 0 ? "Direction Value" : undefined}
                                                                selectedKey={row.directionValue}
                                                                options={directionValues}
                                                                onChange={(_, option) => this.handleDirectionMappingRowChange(idx, 'directionValue', option.key)}
                                                                placeholder="Select Direction Value"
                                                                style={{ width: 250 }}
                                                                disabled={this.props.data !== null && this.props.data.isArchived}
                                                            />
                                                            <IconButton
                                                                iconProps={{ iconName: "Delete" }}
                                                                title="Remove"
                                                                ariaLabel="Remove"
                                                                onClick={() => this.handleRemoveDirectionMappingRowUI(idx)}
                                                                disabled={this.state.xmlDirectionMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                            />
                                                            {idx === this.state.xmlDirectionMappingRows.length - 1 && canAddMoreRows && (
                                                                <IconButton
                                                                    iconProps={{ iconName: "Add" }}
                                                                    title="Add"
                                                                    ariaLabel="Add"
                                                                    onClick={this.handleAddDirectionMappingRowUI}
                                                                    disabled={this.props.data !== null && this.props.data.isArchived || !row.xmlKey}
                                                                />
                                                            )}
                                                        </Stack>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                    <Separator />

                                    <Label>{context.getTranslation("configuration", "timeZone")}</Label>
                                    <ComboBox
                                        selectedKey={this.state.xmlTimeZone}
                                        options={this.state.timezonesList.map(tz => ({ key: tz, text: tz }))}
                                        onChange={(_, option) => this.setState({ xmlTimeZone: option.key })}
                                        placeholder="Select Timezone"
                                        allowFreeform={true}
                                        autoComplete="on"
                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                    />
                                    <Label>{context.getTranslation("configuration", "dateTimeFormat")}</Label>
                                    <ComboBox
                                        text={this.state.xmlDateTimeFormat}
                                        options={[
                                            { key: "yyyy-MM-dd HH:mm:ss", text: "yyyy-MM-dd HH:mm:ss" },
                                            { key: "yyyy-MM-ddTHH:mm:ss.fff", text: "yyyy-MM-ddTHH:mm:ss.fff" },
                                            { key: "UnixSeconds", text: "Unix seconds" }
                                        ]}
                                        onChange={(_, option, __, value) => this.setState({ xmlDateTimeFormat: option ? option.key : value })}
                                        allowFreeform={true}
                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                    />
                                    <Label>{context.getTranslation("configuration", "participantMapType")}</Label>
                                    <ComboBox
                                        selectedKey={this.state.xmlParticipantMapType}
                                        options={[
                                            { key: "Single", text: "Single" },
                                            { key: "Multi", text: "Multi" }
                                        ]}
                                        onChange={(_, option) => this.setState({ xmlParticipantMapType: option.key })}
                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                    />

                                    <Separator />

                                    {this.state.uploadedXMLFile &&
                                        <DefaultButton
                                            id="validate-metadata-mapping"
                                            onClick={this.validateMetadataImport}
                                            text="Validate Metadata Mapping"
                                            disabled={!this.isMetadataMappingReady()}
                                        />
                                    }
                                </>)}

                            </div>
                            <div>
                                {/*JSON custom field mapping*/}
                                {this.state.uploadedJsonMappings && (
                                    <div>
                                        <Label>{context.getTranslation("configuration", "customFieldMapping")}</Label>
                                        {(this.state.jsonCustomFieldsMappingRows || []).map((row, idx) => {
                                            // Get all possible JSON paths from uploadedJsonMappings
                                            const allJsonPaths = Object.keys(this.state.uploadedJsonMappings.customFieldMapping || {});
                                            const allCustomFields = (this.props.customfieldsdata || []).map(f => ({ key: f.id, text: f.fieldName }));
                                            const selectedJsonPaths = (this.state.jsonCustomFieldsMappingRows || []).map(r => r.jsonPath);
                                            const selectedCustomFields = (this.state.jsonCustomFieldsMappingRows || []).map(r => r.customField);
                                            const availableJsonPaths = allJsonPaths.filter(opt => !selectedJsonPaths.includes(opt) || opt === row.jsonPath);
                                            const availableCustomFields = allCustomFields.filter(opt => !selectedCustomFields.includes(opt.key) || opt.key === row.customField);
                                            const jsonPathValue = row.jsonPath ? this.state.uploadedJsonMappings.customFieldMapping[row.jsonPath] : '';
                                            const canAddMoreRows = this.state.jsonCustomFieldsMappingRows.length < allJsonPaths.length && this.state.jsonCustomFieldsMappingRows.length < allCustomFields.length;
                                            return (
                                                <div key={idx}>
                                                    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                        <ComboBox
                                                            label={idx === 0 ? "JSON Path" : undefined}
                                                            selectedKey={row.jsonPath}
                                                            options={availableJsonPaths.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleJsonCustomFieldsMappingRowChange(idx, 'jsonPath', option.key)}
                                                            placeholder="Select JSON Path"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <ComboBox
                                                            label={idx === 0 ? "Custom Field" : undefined}
                                                            selectedKey={row.customField}
                                                            options={availableCustomFields}
                                                            onChange={(_, option) => this.handleJsonCustomFieldsMappingRowChange(idx, 'customField', option.key)}
                                                            placeholder="Select Custom Field"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <IconButton
                                                            iconProps={{ iconName: "Delete" }}
                                                            title="Remove"
                                                            ariaLabel="Remove"
                                                            onClick={() => this.handleRemoveJsonCustomFieldsMappingRowUI(idx)}
                                                            disabled={this.state.jsonCustomFieldsMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                        />
                                                        {idx === this.state.jsonCustomFieldsMappingRows.length - 1 && canAddMoreRows && (
                                                            <IconButton
                                                                iconProps={{ iconName: "Add" }}
                                                                title="Add"
                                                                ariaLabel="Add"
                                                                onClick={this.handleAddJsonCustomFieldsMappingRowUI}
                                                                disabled={this.props.data !== null && this.props.data.isArchived || !row.jsonPath}
                                                            />
                                                        )}
                                                    </Stack>
                                                    {row.jsonPath && this.state.uploadedJSONFile && (
                                                        <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                            Value: {jsonPathValue}
                                                        </Text>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        {this.state.uploadedJSONFile &&
                                            <DefaultButton
                                                id="validate-custom-fields-mapping"
                                                onClick={this.validateCustomFieldImport}
                                                text="Validate Custom Field Mapping"
                                                disabled={!this.isCustomFieldMappingReady()} />
                                        }                                    </div>
                                )}

                                {/*JSON Metadata mapping*/}


                                {this.state.uploadedJsonMappings && (
                                    <div>

                                        {/*----------------------- Metadata mapping---------------------------------*/}

                                        <Separator />
                                        <Label>{context.getTranslation("configuration", "metadataMapping")} </Label>
                                        {(this.state.jsonMetadataMappingRows || []).map((row, idx) => {
                                            const allJsonPaths = Object.keys(this.state.uploadedJsonMappings.MetadataMapping.MetadataMappings || {});
                                            // You can use the same predefined values as XML, or adjust as needed for JSON
                                            const predefinedValues = [
                                                "ScenarioId",
                                                "CallId",
                                                "Header",
                                                "ConversationType (Direction)",
                                                "CallStart",
                                                "CallEnd",
                                                "Duration",
                                                "Participants",
                                                "TTL",
                                            ];
                                            const selectedJsonPaths = (this.state.jsonMetadataMappingRows || []).map(r => r.jsonPath);
                                            const selectedValues = (this.state.jsonMetadataMappingRows || []).map(r => r.value);
                                            const availableJsonPaths = allJsonPaths.filter(opt => !selectedJsonPaths.includes(opt) || opt === row.jsonPath);
                                            const availableValues = predefinedValues.filter(opt => !selectedValues.includes(opt) || opt === row.value);
                                            const jsonPathValue = row.jsonPath ? this.state.uploadedJsonMappings.MetadataMapping.MetadataMappings[row.jsonPath] : '';
                                            const canAddMoreRows = this.state.jsonMetadataMappingRows.length < allJsonPaths.length && this.state.jsonMetadataMappingRows.length < predefinedValues.length;

                                            return (
                                                <div key={idx}>
                                                    <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                        <ComboBox
                                                            label={idx === 0 ? "JSON Path" : undefined}
                                                            selectedKey={row.jsonPath}
                                                            options={availableJsonPaths.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleJsonMetadataMappingRowChange(idx, 'jsonPath', option.key)}
                                                            placeholder="Select JSON Path"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <ComboBox
                                                            label={idx === 0 ? "Value" : undefined}
                                                            selectedKey={row.value}
                                                            options={availableValues.map(opt => ({ key: opt, text: opt }))}
                                                            onChange={(_, option) => this.handleJsonMetadataMappingRowChange(idx, 'value', option.key)}
                                                            placeholder="Select Value"
                                                            style={{ width: 250 }}
                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                        />
                                                        <IconButton
                                                            iconProps={{ iconName: "Delete" }}
                                                            title="Remove"
                                                            ariaLabel="Remove"
                                                            onClick={() => this.handleRemoveJsonMetadataMappingRowUI(idx)}
                                                            disabled={this.state.jsonMetadataMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                        />
                                                        {idx === this.state.jsonMetadataMappingRows.length - 1 && canAddMoreRows && (
                                                            <IconButton
                                                                iconProps={{ iconName: "Add" }}
                                                                title="Add"
                                                                ariaLabel="Add"
                                                                onClick={this.handleAddJsonMetadataMappingRowUI}
                                                                disabled={this.props.data !== null && this.props.data.isArchived || !row.jsonPath}
                                                            />
                                                        )}
                                                    </Stack>
                                                    {row.jsonPath && this.state.uploadedJSONFile && (
                                                        <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                            Value: {jsonPathValue}
                                                        </Text>
                                                    )}
                                                </div>
                                            );
                                        })}



                                        {/*----------------------- Participant mapping---------------------------------*/}
                                        {Array.isArray(this.state.uploadedJsonMappings?.MetadataMapping?.ParticipantMappings) &&
                                            this.state.uploadedJsonMappings.MetadataMapping.ParticipantMappings.length > 0 && (
                                                <div>
                                                    <Separator />
                                                    <Label>{context.getTranslation("configuration", "participantDataMapping")} </Label>
                                                    {this.state.jsonParticipantMappingRows.map((participantRow, idx) => {
                                                        // Get the Mapping object from uploadedJsonMappings for this participant
                                                        const mappingObj =
                                                            this.state.uploadedJsonMappings.MetadataMapping.ParticipantMappings[idx]?.Mapping || {};

                                                        // All possible mapping keys (the JSON paths)
                                                        const mappingEntries = Object.entries(mappingObj);
                                                        const mappingJsonPathsOrKeys = mappingEntries.map(([key]) => key);

                                                        // Device display name options
                                                        const deviceDisplayNameOptions = [
                                                            { key: 'DeviceDisplayName', text: 'DeviceDisplayName' },
                                                            { key: 'DisplayName', text: 'DisplayName' }
                                                        ];

                                                        const checkboxFieldsRow1 = ['IsCaller', 'IsCalled', 'IsCallOwner'];

                                                        return (
                                                            <div key={idx} style={{ marginBottom: 16, border: '1px solid #eee', padding: 3 }}>
                                                                <Label>{context.getTranslation("configuration", "participant") + ' ' + (idx + 1)}</Label>
                                                                {participantRow.Mappings.map((row, mIdx) => {
                                                                    // Selected mapping keys in UI
                                                                    const selectedKeys = participantRow.Mappings.map(r => r.mappingKey);

                                                                    // Available mapping keys for dropdown (avoid duplicates except current)
                                                                    const availableMappingKeys = mappingJsonPathsOrKeys
                                                                        .filter(opt => !selectedKeys.includes(opt) || opt === row.mappingKey)
                                                                        .map(opt => ({
                                                                            key: opt,
                                                                            text: opt // opt is always a string (the json path)
                                                                        }));

                                                                    // Get mapping value from mappingObj
                                                                    const mappingValue = mappingObj[row.mappingKey] || '';

                                                                    return (
                                                                        <div key={mIdx}>
                                                                            <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                                                <ComboBox
                                                                                    label={mIdx === 0 ? "Mapping Key" : undefined}
                                                                                    selectedKey={row.mappingKey}
                                                                                    options={availableMappingKeys}
                                                                                    onChange={(_, option) => this.handleJsonParticipantMappingRowChange(idx, mIdx, 'mappingKey', option.key)}
                                                                                    placeholder="Select Mapping Key"
                                                                                    style={{ width: 250 }}
                                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                                />
                                                                                <ComboBox
                                                                                    label={mIdx === 0 ? "Value" : undefined}
                                                                                    selectedKey={row.value}
                                                                                    options={deviceDisplayNameOptions}
                                                                                    onChange={(_, option) => this.handleJsonParticipantMappingRowChange(idx, mIdx, 'value', option.key)}
                                                                                    placeholder="Select Value"
                                                                                    style={{ width: 250 }}
                                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                                />
                                                                                <IconButton
                                                                                    iconProps={{ iconName: "Delete" }}
                                                                                    title="Remove"
                                                                                    ariaLabel="Remove"
                                                                                    onClick={() => this.handleRemoveJsonParticipantMappingRowUI(idx, mIdx)}
                                                                                    disabled={participantRow.Mappings.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                                                />
                                                                                {mIdx === participantRow.Mappings.length - 1 && (
                                                                                    <IconButton
                                                                                        iconProps={{ iconName: "Add" }}
                                                                                        title="Add"
                                                                                        ariaLabel="Add"
                                                                                        onClick={() => this.handleAddJsonParticipantMappingRowUI(idx)}
                                                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                                                    />
                                                                                )}
                                                                            </Stack>
                                                                            {row.mappingKey && this.state.uploadedJSONFile && (
                                                                                <Text style={{ marginLeft: 4, marginBottom: 8 }}>
                                                                                    Value: {mappingValue}
                                                                                </Text>
                                                                            )}
                                                                        </div>
                                                                    );
                                                                })}
                                                                <Stack horizontal tokens={{ childrenGap: 16 }} style={{ marginBottom: 4 }}>
                                                                    {checkboxFieldsRow1.map(field => (
                                                                        <Checkbox
                                                                            key={field}
                                                                            label={field}
                                                                            checked={participantRow[field] === true}
                                                                            onChange={(_, checked) => this.handleJsonParticipantMappingCheckboxChange(idx, field, checked)}
                                                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                                                        />
                                                                    ))}
                                                                </Stack>
                                                                <Stack tokens={{ childrenGap: 16 }}>
                                                                    <TextField
                                                                        label="IsCallOwnerCheckField"
                                                                        value={participantRow.IsCallOwnerCheckField || ""}
                                                                        onChange={(_, newValue) => {
                                                                            const rows = [...this.state.jsonParticipantMappingRows];
                                                                            rows[idx].IsCallOwnerCheckField = newValue;
                                                                            this.setState({ jsonParticipantMappingRows: rows });
                                                                        }}
                                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                                        style={{ width: 180 }}
                                                                    />
                                                                </Stack>
                                                                <Stack tokens={{ childrenGap: 8 }}>
                                                                    <Label>IsInternalCheckField</Label>
                                                                    {(() => {
                                                                        // Convert IsInternalCheckField to array if needed
                                                                        const entries = Array.isArray(participantRow.IsInternalCheckField)
                                                                            ? participantRow.IsInternalCheckField
                                                                            : Object.entries(participantRow.IsInternalCheckField || {}).map(([jsonFieldName, logicalProperty]) => ({ jsonFieldName, logicalProperty }));

                                                                        const displayEntries = entries.length > 0 ? entries : [{ jsonFieldName: "", logicalProperty: "" }];

                                                                        return displayEntries.map((entry, entryIdx, arr) => (
                                                                            <Stack
                                                                                horizontal
                                                                                tokens={{ childrenGap: 8 }}
                                                                                key={entryIdx}
                                                                                verticalAlign="end"
                                                                                style={{ width: 470, justifyContent: "space-between", marginBottom: 8 }}
                                                                            >
                                                                                <Stack horizontal tokens={{ childrenGap: 4 }} style={{ flexGrow: 1 }}>
                                                                                    <TextField
                                                                                        label="Field"
                                                                                        value={entry.jsonFieldName}
                                                                                        onChange={(_, newValue) => {
                                                                                            const updatedArray = [...displayEntries];
                                                                                            updatedArray[entryIdx] = { ...updatedArray[entryIdx], jsonFieldName: newValue };
                                                                                            const updatedObj = {};
                                                                                            updatedArray.forEach(({ jsonFieldName, logicalProperty }) => {
                                                                                                if (jsonFieldName) updatedObj[jsonFieldName] = logicalProperty;
                                                                                            });
                                                                                            const rows = [...this.state.jsonParticipantMappingRows];
                                                                                            rows[idx].IsInternalCheckField = updatedObj;
                                                                                            this.setState({ jsonParticipantMappingRows: rows });
                                                                                        }}
                                                                                        style={{ width: 250 }}
                                                                                    />
                                                                                    <ComboBox
                                                                                        label="Value"
                                                                                        selectedKey={entry.logicalProperty}
                                                                                        options={userProperties.map(p => ({ key: p, text: p }))}
                                                                                        onChange={(_, option) => {
                                                                                            const updatedArray = [...displayEntries];
                                                                                            updatedArray[entryIdx] = { ...updatedArray[entryIdx], logicalProperty: option.key };
                                                                                            const updatedObj = {};
                                                                                            updatedArray.forEach(({ jsonFieldName, logicalProperty }) => {
                                                                                                if (jsonFieldName) updatedObj[jsonFieldName] = logicalProperty;
                                                                                            });
                                                                                            const rows = [...this.state.jsonParticipantMappingRows];
                                                                                            rows[idx].IsInternalCheckField = updatedObj;
                                                                                            this.setState({ jsonParticipantMappingRows: rows });
                                                                                        }}
                                                                                        style={{ width: 250 }}
                                                                                    />
                                                                                </Stack>
                                                                                <Stack horizontal tokens={{ childrenGap: 4 }}>
                                                                                    <IconButton
                                                                                        iconProps={{ iconName: "Delete" }}
                                                                                        title="Remove"
                                                                                        ariaLabel="Remove"
                                                                                        onClick={() => {
                                                                                            let updated = [...displayEntries];
                                                                                            updated.splice(entryIdx, 1);
                                                                                            if (updated.length === 0) updated = [{ jsonFieldName: "", logicalProperty: "" }];
                                                                                            const rows = [...this.state.jsonParticipantMappingRows];
                                                                                            rows[idx].IsInternalCheckField = updated;
                                                                                            this.setState({ jsonParticipantMappingRows: rows });
                                                                                        }}
                                                                                    />
                                                                                    {entryIdx === arr.length - 1 && (
                                                                                        <IconButton
                                                                                            iconProps={{ iconName: "Add" }}
                                                                                            title="Add"
                                                                                            ariaLabel="Add"
                                                                                            onClick={() => {
                                                                                                const updated = [...displayEntries, { jsonFieldName: "", logicalProperty: "" }];
                                                                                                const rows = [...this.state.jsonParticipantMappingRows];
                                                                                                rows[idx].IsInternalCheckField = updated;
                                                                                                this.setState({ jsonParticipantMappingRows: rows });
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                </Stack>
                                                                            </Stack>
                                                                        ));
                                                                    })()}
                                                                </Stack>

                                                            </div>
                                                        );
                                                    })}


                                                </div>
                                            )
                                        }


                                        {/*--------PostParticipantMappingRules ------------*/}
                                        <Separator />
                                        <Label>Post Participant Mapping Rules</Label>
                                        {this.state.jsonPostParticipantMappingRules.map((rule, idx) => (
                                            <Stack tokens={{ childrenGap: 8 }} key={idx} style={{ marginBottom: 8 }}>
                                                {/* First row: ParticipantTargetField & MetadataFieldPath */}
                                                <Stack horizontal tokens={{ childrenGap: 8 }} style={{ marginBottom: 4 }}>
                                                    <ComboBox
                                                        label="Comparison Method"
                                                        selectedKey={rule.ComparisonMethod}
                                                        options={[
                                                            { key: "Equals", text: "Equals" },
                                                            { key: "NotEquals", text: "NotEquals" }
                                                        ]}
                                                        onChange={(_, option) => {
                                                            const rules = [...this.state.jsonPostParticipantMappingRules];
                                                            rules[idx].ComparisonMethod = option.key;
                                                            this.setState({ jsonPostParticipantMappingRules: rules });
                                                        }}
                                                        style={{ width: 250 }}
                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                    />
                                                    <ComboBox
                                                        label="Participant Target Field"
                                                        selectedKey={rule.ParticipantTargetField}
                                                        options={[
                                                            { key: "DeviceDisplayName", text: "DeviceDisplayName" },
                                                            { key: "DisplayName", text: "DisplayName" }
                                                        ]}
                                                        onChange={(_, option) => {
                                                            const rules = [...this.state.jsonPostParticipantMappingRules];
                                                            rules[idx].ParticipantTargetField = option.key;
                                                            this.setState({ jsonPostParticipantMappingRules: rules });
                                                        }}
                                                        style={{ width: 250 }}
                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                    />

                                                </Stack>
                                                <Stack horizontal tokens={{ childrenGap: 8 }}>
                                                    <ComboBox
                                                        label="Metadata Field Path"
                                                        selectedKey={rule.MetadataFieldPath}
                                                        options={[
                                                            // Always include the selected key if not present in the mapping
                                                            ...(
                                                                Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {})
                                                                    .map(key => ({ key, text: key }))
                                                            ),
                                                            ...(rule.MetadataFieldPath &&
                                                                !Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {}).includes(rule.MetadataFieldPath)
                                                                ? [{ key: rule.MetadataFieldPath, text: rule.MetadataFieldPath }]
                                                                : []
                                                            )
                                                        ]}
                                                        onChange={(_, option) => {
                                                            const rules = [...this.state.jsonPostParticipantMappingRules];
                                                            rules[idx].MetadataFieldPath = option.key;
                                                            this.setState({ jsonPostParticipantMappingRules: rules });
                                                        }}
                                                        style={{ width: 250 }}
                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                    />
                                                    <ComboBox
                                                        label="Reason"
                                                        selectedKey={rule.Reason}
                                                        options={[
                                                            ...(
                                                                Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {})
                                                                    .map(key => ({ key, text: key }))
                                                            ),
                                                            ...(rule.Reason &&
                                                                !Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {}).includes(rule.Reason)
                                                                ? [{ key: rule.Reason, text: rule.Reason }]
                                                                : []
                                                            )
                                                        ]}
                                                        onChange={(_, option) => {
                                                            const rules = [...this.state.jsonPostParticipantMappingRules];
                                                            rules[idx].Reason = option.key;
                                                            this.setState({ jsonPostParticipantMappingRules: rules });
                                                        }}
                                                        style={{ width: 250 }}
                                                        disabled={this.props.data !== null && this.props.data.isArchived}
                                                    />
                                                </Stack>
                                            </Stack>
                                        ))}
                                        {/*----------------------- Direction mapping---------------------------------*/}
                                        {this.state.uploadedJsonMappings?.MetadataMapping?.DirectionMappings && (
                                            <div>
                                                <Separator />
                                                <Label>{context.getTranslation("configuration", "directionMapping")}</Label>
                                                {(this.state.jsonDirectionMappingRows || []).map((row, idx) => {
                                                    const directionKeys = Object.keys(this.state.uploadedJsonMappings.MetadataMapping.DirectionMappings || {});
                                                    const directionValues = [
                                                        { key: "Internal", text: "Internal" },
                                                        { key: "Inbound", text: "Inbound" },
                                                        { key: "Outbound", text: "Outbound" },
                                                        { key: "Incoming", text: "Incoming" },
                                                        { key: "Outgoing", text: "Outgoing" }
                                                    ];
                                                    const selectedKeys = (this.state.jsonDirectionMappingRows || []).map(r => r.jsonKey);
                                                    const availableKeys = directionKeys.filter(opt => !selectedKeys.includes(opt) || opt === row.jsonKey);
                                                    const canAddMoreRows = this.state.jsonDirectionMappingRows.length < directionKeys.length && this.state.jsonDirectionMappingRows.length < directionValues.length;
                                                    return (
                                                        <div key={idx}>
                                                            <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="end" style={{ marginBottom: 8 }}>
                                                                <ComboBox
                                                                    label={idx === 0 ? " Direction" : undefined}
                                                                    selectedKey={row.jsonKey}
                                                                    options={availableKeys.map(opt => ({ key: opt, text: opt }))}
                                                                    onChange={(_, option) => this.handleJsonDirectionMappingRowChange(idx, 'jsonKey', option.key)}
                                                                    placeholder="Select Direction"
                                                                    style={{ width: 250 }}
                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                />
                                                                <ComboBox
                                                                    label={idx === 0 ? "Direction Value" : undefined}
                                                                    selectedKey={row.directionValue}
                                                                    options={directionValues}
                                                                    onChange={(_, option) => this.handleJsonDirectionMappingRowChange(idx, 'directionValue', option.key)}
                                                                    placeholder="Select Direction Value"
                                                                    style={{ width: 250 }}
                                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                                />
                                                                <IconButton
                                                                    iconProps={{ iconName: "Delete" }}
                                                                    title="Remove"
                                                                    ariaLabel="Remove"
                                                                    onClick={() => this.handleRemoveJsonDirectionMappingRowUI(idx)}
                                                                    disabled={this.state.jsonDirectionMappingRows.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                                                />
                                                                {idx === this.state.jsonDirectionMappingRows.length - 1 && canAddMoreRows && (
                                                                    <IconButton
                                                                        iconProps={{ iconName: "Add" }}
                                                                        title="Add"
                                                                        ariaLabel="Add"
                                                                        onClick={this.handleAddJsonDirectionMappingRowUI}
                                                                        disabled={this.props.data !== null && this.props.data.isArchived || !row.jsonKey}
                                                                    />
                                                                )}
                                                            </Stack>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {/*-----------------------Final Direction mapping---------------------------------*/}

                                        <Separator />
                                        <Label>Final Direction Mapping Rule</Label>
                                        <Stack tokens={{ childrenGap: 8 }} style={{ marginBottom: 8 }}>
                                            <Stack horizontal tokens={{ childrenGap: 8 }} style={{ marginBottom: 4 }}>
                                                <ComboBox
                                                    label="Participant Target Field"
                                                    selectedKey={this.state.FinalDirectionMappingRule.ParticipantTargetField}
                                                    options={[
                                                        { key: "DeviceDisplayName", text: "DeviceDisplayName" },
                                                        { key: "DisplayName", text: "DisplayName" }
                                                    ]}
                                                    onChange={(_, option) => {
                                                        this.setState({
                                                            FinalDirectionMappingRule: {
                                                                ...this.state.FinalDirectionMappingRule,
                                                                ParticipantTargetField: option.key
                                                            }
                                                        });
                                                    }}
                                                    style={{ width: 250 }}
                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                />
                                                <ComboBox
                                                    label="Metadata Field Path"
                                                    selectedKey={this.state.FinalDirectionMappingRule.MetadataFieldPath}
                                                    options={[
                                                        ...Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {})
                                                            .map(key => ({ key, text: key })),
                                                        ...(this.state.FinalDirectionMappingRule.MetadataFieldPath &&
                                                            !Object.keys(this.state.uploadedJsonMappings?.MetadataMapping?.MetadataMappings || {})
                                                                .includes(this.state.FinalDirectionMappingRule.MetadataFieldPath)
                                                            ? [{ key: this.state.FinalDirectionMappingRule.MetadataFieldPath, text: this.state.FinalDirectionMappingRule.MetadataFieldPath }]
                                                            : []
                                                        )
                                                    ]}
                                                    onChange={(_, option) => {
                                                        this.setState({
                                                            FinalDirectionMappingRule: {
                                                                ...this.state.FinalDirectionMappingRule,
                                                                MetadataFieldPath: option.key
                                                            }
                                                        });
                                                    }}
                                                    style={{ width: 250 }}
                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                />
                                            </Stack>
                                            <Stack horizontal tokens={{ childrenGap: 8 }}>
                                                <Checkbox
                                                    label="Is Caller"
                                                    checked={this.state.FinalDirectionMappingRule.IsCaller}
                                                    onChange={(_, checked) => {
                                                        this.setState({
                                                            FinalDirectionMappingRule: {
                                                                ...this.state.FinalDirectionMappingRule,
                                                                IsCaller: checked
                                                            }
                                                        });
                                                    }}
                                                    disabled={this.props.data !== null && this.props.data.isArchived}
                                                />
                                            </Stack>
                                        </Stack>

                                        {/*----------------------- other mapping---------------------------------*/}

                                        <Separator />

                                        <Label>{context.getTranslation("configuration", "timeZone")}</Label>
                                        <ComboBox
                                            selectedKey={this.state.jsonTimeZone}
                                            options={this.state.timezonesList.map(tz => ({ key: tz, text: tz }))}
                                            onChange={(_, option) => this.setState({ jsonTimeZone: option.key })}
                                            placeholder="Select Timezone"
                                            allowFreeform={true}
                                            autoComplete="on"
                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                        />
                                        <Label>{context.getTranslation("configuration", "dateTimeFormat")}</Label>
                                        <ComboBox
                                            text={this.state.jsonDateTimeFormat}
                                            options={[
                                                { key: "yyyy-MM-dd HH:mm:ss", text: "yyyy-MM-dd HH:mm:ss" },
                                                { key: "yyyy-MM-ddTHH:mm:ss.fff", text: "yyyy-MM-ddTHH:mm:ss.fff" },
                                                { key: "UnixSeconds", text: "UnixSeconds" }
                                            ]}
                                            onChange={(_, option, __, value) => this.setState({ jsonDateTimeFormat: option ? option.key : value })}
                                            allowFreeform={true}
                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                        />
                                        <Label>{context.getTranslation("configuration", "participantMapType")}</Label>
                                        <ComboBox
                                            selectedKey={this.state.jsonParticipantMapType}
                                            options={[
                                                { key: "Single", text: "Single" },
                                                { key: "Multi", text: "Multi" }
                                            ]}
                                            onChange={(_, option) => this.setState({ jsonParticipantMapType: option.key })}
                                            disabled={this.props.data !== null && this.props.data.isArchived}
                                        />

                                        <Separator />

                                        {this.state.uploadedJSONFile &&
                                            <DefaultButton
                                                id="validate-metadata-mapping"
                                                onClick={this.validateMetadataImport}
                                                text="Validate Metadata Mapping"
                                                disabled={!this.isMetadataMappingReady()}
                                            />
                                        }
                                    </div>
                                )}
                            </div>

                            <br />
                            <hr />
                        </>}




                        {/*----------------------------END Generic metadata mapping-----------------*/}


                        {/*-----------------Neo custom field mapping-----------------*/}
                        {["Neo", "NeoTransfer"].includes(this.state.importType) && <>

                            {/* --- Custom Field Mapping Section --- */}
                            <Label >{context.getTranslation("configuration", "customFieldMapping")}</Label>
                            {this.state.customFieldsMapping.map((item, idx) => {
                                // Generate options for CUSTOMCP01 to CUSTOMCP30
                                const allCustomFields = Array.from({ length: 30 }, (_, i) => `CUSTOMCP${(i + 1).toString().padStart(2, '0')}`);
                                // Exclude already-selected keys except for the current row
                                const selectedKeys = this.state.customFieldsMapping.map((f, i) => i !== idx ? f.key : null).filter(Boolean);
                                const availableKeys = allCustomFields.filter(opt => !selectedKeys.includes(opt) || opt === item.key);


                                return (
                                    <Stack horizontal tokens={{ childrenGap: 8 }} key={idx} verticalAlign="end" style={{ marginBottom: 8 }}>
                                        <ComboBox
                                            label={idx === 0 ? (context.getTranslation("configuration", "customfield")) : undefined}
                                            selectedKey={item.key}
                                            options={availableKeys.map(opt => ({ key: opt, text: opt }))}
                                            onChange={(_, option) => this.handleCustomFieldChange(idx, "key", option.key)}
                                            placeholder="Field"
                                            style={{ width: 180 }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        />
                                        <ComboBox
                                            label={idx === 0 ? (context.getTranslation("detailContainer", "value")) : undefined}
                                            selectedKey={item.value}
                                            options={
                                                (this.props.customfieldsdata || []).map(f => ({
                                                    key: f.id,
                                                    text: f.fieldName
                                                }))
                                            }
                                            onChange={(_, option) => this.handleCustomFieldChange(idx, "value", option.key)}
                                            placeholder="Value"
                                            style={{ width: 180 }}
                                            disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}
                                        />
                                        <IconButton
                                            iconProps={{ iconName: "Delete" }}
                                            title="Remove"
                                            ariaLabel="Remove"
                                            onClick={() => this.handleRemoveCustomField(idx)}
                                            disabled={this.state.customFieldsMapping.length === 1 || (this.props.data !== null && this.props.data.isArchived)}
                                        />
                                        {idx === this.state.customFieldsMapping.length - 1 && (
                                            <IconButton
                                                iconProps={{ iconName: "Add" }}
                                                title="Add"
                                                ariaLabel="Add"
                                                onClick={this.handleAddCustomField}
                                                disabled={(this.props.data !== null && this.props.data.isArchived)}
                                            />
                                        )}
                                    </Stack>
                                );



                            })}
                            <br />
                            <hr />
                        </>}
                        {/*------------------End Neo custom field mapping-----------------*/}


                        <ChoiceGroup
                            selectedKey={this.state.mappingType}
                            style={{ width: "200px" }}
                            options={[
                                ...(!["Verint", "Generic"].includes(this.state.importType) ? [{
                                    key: 'UsersToUsers',
                                    text: context.getTranslation("configuration", "usertouser"),
                                    'data-automation-id': 'auto1',
                                    styles: { field: { fontWeight: FontWeights.regular } },
                                }] : []),
                                // Conditionally include UsersToComplianceOfficer
                                ...(!["Abelia", "NeoTransfer", "DC", "Kerv", "Crealog", "Aiphoria", "DamovoVerint"].includes(this.state.importType) ? [{
                                    key: 'UsersToComplianceOfficer',
                                    text: context.getTranslation("configuration", "userstocomplianceofficer"),
                                    styles: { field: { fontWeight: FontWeights.regular } }
                                }] : [])
                            ]}
                        onChange={(event, newValue) => {
                            this.setState({
                                mappingType: newValue.key,
                                updated: true
                            });
                        }}
                        label={context.getTranslation("configuration", "mappingType")}
                        disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                        />
                        {this.state.mappingType == "UsersToComplianceOfficer" && <Stack.Item>
                            <UserPicker
                                user={this.state.mappingUserId}
                                displayType={"noGroups"}
                                fc={(user) => {
                                    this.setState({
                                        mappingUserId: user && user.length > 0 ? [user[user.length - 1]] : []
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                        </Stack.Item>}
                        {(this.state.mappingType == "UsersToUsers" && ["API8x8", "Verba", "Kerv", "Abelia", "Dubber", "DC", "Recordia", "Neo", "NeoTransfer", "Crealog", "Aiphoria", "Generic", "DamovoVerint"].includes(this.state.importType)) && <Stack.Item>
                            <Label>{context.getTranslation("configuration", "fallbackUser")}</Label>

                            <UserPicker
                                user={this.state.mappingUserId}
                                displayType={"noGroups"}
                                fc={(user) => {
                                    this.setState({
                                        mappingUserId: user && user.length > 0 ? [user[user.length - 1]] : []
                                    });
                                }}
                                disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                            />
                        </Stack.Item>}
                        <br />
                        <hr />
                        {(["Neo", "NeoTransfer"].includes(this.state.importType)) && <Stack.Item>
                            <Checkbox
                                label={context.getTranslation("configuration", "createUnmixedEnhancement")}
                                checked={this.state.createUnmixedEnhancement}
                                onChange={(_, checked) => this.setState({ createUnmixedEnhancement: checked })}
                                disabled={this.props.data !== null && this.props.data.isArchived}
                            />
                        </Stack.Item>
                        }
                        <Query
                            query={getProcessingRegions}
                            variables={this.props.authorization} >
                            {({ loading, error, data }) => {
                                if (loading) return <div>
                                    <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                </div>;
                                if (error) return <h1> </h1>;

                                if (data.getProcessingRegions == null) {
                                    return <div></div>;
                                }

                                this.tmpKey = [];
                                const license = data.getProcessingRegions;
                                if (data.getProcessingRegions != null) {
                                    for (let x = 0; x < license.length; x++) {
                                        let i = {
                                            key: license[x],
                                            text: license[x],
                                        };
                                        this.tmpKey.push(i);
                                    }
                                }


                                return <ComboBox
                                    style={{ width: "300px" }}
                                    placeholder="Select an option"
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "processingRegion")}</>)}</MyContext.Consumer>}
                                    options={this.tmpKey}
                                    selectedKey={this.state.processingRegion}
                                    onChange={(ev, newVal) => {
                                        this.setState({
                                            processingRegion: newVal.key,
                                            updated: true
                                        });
                                    }}
                                    disabled={(this.props.data !== null && this.props.data.isArchived) ? true : false}

                                />
                            }
                            }

                        </Query>

                        <br />

                        <br />

                        <Stack.Item>
                            {(this.props.data !== null && this.props.data.isArchived)
                                ? <></>
                                : <PrimaryButton onClick={this.savePanel} text={context.getTranslation("common", "save")} disabled={!this.isValid()} />
                            }
                            <DefaultButton onClick={this.resetState} text={context.getTranslation("common", "cancel")} />
                            {(this.props.data !== null && !this.state.enabled && !this.props.data.isArchived) &&
                                <DefaultButton style={{ background: "red", color: "white", marginLeft: "5px" }} onClick={this.deleteImportJob} text={context.getTranslation("configuration", "deleteJob")} disabled={this.state.jobDeletionActive} />
                            }
                        </Stack.Item>
                    </Stack>
                )
                }
            </MyContext.Consumer>
        );
    }

    storageConnectionStringPlaceHolder = () => {
        var placeholderText = "";
        switch (this.state.importType) {
            case "Neo": break;
            case "RedBox": break;
            case "ASCRI": break;
            case "Numonix": break;
            case "Genesys": break;
            case "Nice": break;
            case "Dubber": break;
            case "API8x8":
                placeholderText = "e.g: clientid =; password =; region =;"
                break;
            default: break;
        }
        return placeholderText;
    }

    isValid = () => {
        const hasValidName = this.state.name != null && this.state.name.length > 0;
        const hasValidMapping = this.state.mappingType != "UsersToComplianceOfficer" || this.state.mappingUserId.length > 0;
        const hasValidUUID = this.state.isValidUUID;

        const needsStorageValidation = this.state.importType !== "NeoTransfer";
        const hasValidStorage = !needsStorageValidation || this.state.validateStorageConnectionString === "true" || (this.state.storageConnectionString === "******" && !this.state.storageConnectionStringChanged);

        const valid = hasValidName && hasValidMapping && hasValidUUID && hasValidStorage;

        if (this.state.importType === "Generic") {
            const customFieldEmpty = !this.props.data?.customFieldMapping;
            const metadataEmpty = !this.props.data?.metadataMapping;
            const noFile = !this.state.uploadedXMLFile && !this.state.uploadedJSONFile;

            if (customFieldEmpty && metadataEmpty && noFile) return false;
            if (this.state.uploadedXMLFile || this.state.uploadedJSONFile) {
                // If there are no custom field mapping rows to configure, skip custom field validation
                const isJson = this.state.isJson;
                const customFieldRows = isJson ? this.state.jsonCustomFieldsMappingRows : this.state.xmlCustomFieldsMappingRows;
                const hasCustomFieldsToMap = Array.isArray(customFieldRows) && customFieldRows.length > 0;
                const customFieldValid = !hasCustomFieldsToMap || this.state.isCustomFieldMappingValid === true;
                return valid && this.state.isMetadataMappingValid === true && customFieldValid;
            }
            return valid;
        }
        return valid;
    }

    resetState = () => {
        if (this.props.isNew) {
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false,
                name: ""
            });
        } else {
            this.setState({
                isPanelOpen: false,
                isModalOpen: false,
                isChanged: false
            });
        }
        this.props.closeModal();
    }
    deleteImportJob = async () => {
        let importUserGroupIds = [];
        for (let x = 0; x < this.state.userIds.length; x++) {
            importUserGroupIds.push(this.state.userIds[x].key);
        };
        let job =
        {
            id: this.state.id,
            name: this.state.name,
            importType: this.state.importType,
            mappingType: this.state.mappingType,
            mappingUserId: (this.state.mappingUserId != null && this.state.mappingUserId.length > 0) ? this.state.mappingUserId[0].userId : null,
            sourceTtl: this.state.sourceTtlEnabled ? parseInt(this.state.sourceTtl) : -1,
            targetTtl: parseInt(this.state.targetTtl),
            storageConnectionString: this.state.storageConnectionString,
            storageContainerName: this.state.storageContainerName,
            storageRootDirectory: this.state.storageRootDirectory,
            keyVaultConnectionString: this.state.keyVaultConnectionString,
            jobType: {
                intervalType: this.state.intervalType,
                jobStartTime: this.state.jobStartTime === '' ? null : this.state.jobStartTime,
                intervalMonth: parseInt(this.state.intervalMonth),
                intervalDay: parseInt(this.state.intervalDay),
                intervalHour: parseInt(this.state.intervalHour),
                intervalMinute: parseInt(this.state.intervalMinute)
            }
            , enabled: this.state.enabled ? true : false
            , processingRegion: this.state.processingRegion
            , sftpPrivateKeyUpload: this.state.sftpPrivateKeyUpload
            , callStartTime: this.state.callStartTime === '' ? null : this.state.callStartTime
            , callEndTime: this.state.callEndTime === '' ? null : this.state.callEndTime
            , userIds: importUserGroupIds
            , transferId: this.state.transferId
            , mappingFiles: this.state.mappingFiles
            , deletedFilesFromMappingFiles: this.state.deletedFilesFromMappingFiles
            , createUnmixedEnhancement: this.state.createUnmixedEnhancement
        };

        var data = await this.props.apol
            .mutate({
                mutation: mutationMarkDeleteImportRule,
                refetchQueries: [{
                    query: queryGetConfigData,
                    variables: { auth: this.props.authorization },
                }],
                variables: {
                    auth: this.props.authorization,
                    rule: job,
                }
            });

        if (data.data.markDeleteImportRule == null) {
            toast.info('Job delete not successful', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            toast.info('Job moved to archive', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }



        this.setState({ jobDeletionActive: false });
        this.props.closeModal();
    }
    savePanel = () => {
        // Save Changes

        let importUserGroupIds = [];
        for (let x = 0; x < this.state.userIds.length; x++) {
            importUserGroupIds.push(this.state.userIds[x].key);
        };

        // Convert customFieldsMapping array to Dictionary<string, string>
        const customFieldMappingDict = {};
        this.state.customFieldsMapping.forEach(({ key, value }) => {
            if (key) customFieldMappingDict[key] = value;
        });

        let importMappingData = this.state.isJson
            ? this.getJsonImportMappingResult()
            : this.getImportMappingResult();
        let genericCustomFieldMapping = importMappingData.customFieldMapping;
        let neoCustomFieldMapping = JSON.stringify(customFieldMappingDict);

        let job =
        {
            id: this.state.id,
            name: this.state.name,
            importType: this.state.importType,
            mappingType: this.state.mappingType,
            mappingUserId: (this.state.mappingUserId != null && this.state.mappingUserId.length > 0) ? this.state.mappingUserId[0].userId : null,
            sourceTtl: this.state.sourceTtlEnabled ? parseInt(this.state.sourceTtl) : -1,
            targetTtl: parseInt(this.state.targetTtl),
            storageConnectionString: this.state.storageConnectionString,
            storageContainerName: this.state.storageContainerName,
            storageRootDirectory: this.state.storageRootDirectory,
            keyVaultConnectionString: this.state.keyVaultConnectionString,
            jobType: {
                intervalType: this.state.intervalType,
                jobStartTime: this.state.jobStartTime === '' ? null : this.state.jobStartTime,
                intervalMonth: parseInt(this.state.intervalMonth),
                intervalDay: parseInt(this.state.intervalDay),
                intervalHour: parseInt(this.state.intervalHour),
                intervalMinute: parseInt(this.state.intervalMinute)
            },
            enabled: this.state.enabled ? true : false,
            processingRegion: this.state.processingRegion,
            sftpPrivateKeyUpload: this.state.sftpPrivateKeyUpload,
            callStartTime: this.state.callStartTime === '' ? null : this.state.callStartTime,
            callEndTime: this.state.callEndTime === '' ? null : this.state.callEndTime,
            userIds: importUserGroupIds,
            transferId: this.state.transferId,
            customFieldMapping:
                this.state.importType === "Generic"
                    ? JSON.stringify(genericCustomFieldMapping)
                    : (this.state.importType === "Neo" || this.state.importType === "NeoTransfer")
                        ? neoCustomFieldMapping
                        : "",
            metadataMapping: JSON.stringify(importMappingData.MetadataMapping),
            mappingFiles: this.state.mappingFiles,
            deletedFilesFromMappingFiles: this.state.deletedFilesFromMappingFiles,
            createUnmixedEnhancement: this.state.createUnmixedEnhancement


        };
        if (!this.props.isNew) {

            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, $importJob: ImportRuleInputType) {   
                        updateImportJob (
                            input: $input, 
                            importJob: $importJob
                        ) 
                        {
                            id
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.authorization,
                        importJob: job
                    },
                })
                .then((result) => {
                    if (result.data.updateImportJob !== null) {
                        toast.info('Import Job changed', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    } else {
                        toast.error('Import Job not changed', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }

                });
        }
        else {
            this.props.apol
                .mutate({
                    mutation: gql`
                    mutation ent (
                        $input: AuthInput, $importJob: ImportRuleInputType) {
                        createImportJob (
                            input: $input, 
                            importJob: $importJob
                        ) 
                        {
                            id
                        }
                    }
                `,
                    refetchQueries: [{
                        query: queryGetConfigData,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        input: this.props.authorization,
                        importJob: job
                    },
                })
                .then((result) => {
                    if (result.data.createImportJob !== null) {
                        toast.info('Import Job created', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    } else {
                        toast.error('Import Job not created', {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                    }

                });
        }
        this.props.closeModal();


    };
}



export default ImportConfig;